import moment from 'moment';

import { DashboardFilledIcon } from 'components/Icon/apps';
import {
  CollaboratorOutlineIcon,
  CommunityOutlineIcon,
  CompanyOutlineIcon,
  FactoryOutlineIcon,
  FamilyOutlineIcon,
  FarmOutlineIcon,
  OrganizationOutlineIcon,
  SchoolOutlineIcon,
  StoreOutlineIcon,
} from 'components/Icon/templates';
import { env } from 'env';

import { AddressData } from '../api';

export const DEFAULT_SEO = {
  title: 'Hệ thống quản trị toàn diện doanh nghiệp | QUẢN TRỊ',
  icon: 'https://public-asset-cdn.ecovation.vn/master/brand/v3/default_seo_image.png',
  description:
    'Quy trình hóa và tự động hoá toàn diện doanh nghiệp từ khâu sản xuất đến vận hành và bán hàng. Xây dựng thương hiệu và cá nhân hóa thương hiệu cho từng doanh nghiệp với bản sắc độc bản.',
  canonicalUrl: env.service.hubcheckWebApp!,
  ogTwitterImage:
    'https://public-asset-cdn.ecovation.vn/website/seo_banners/hubadmin_seo_banner_1200_630.png',
  ogImageUrl:
    'https://public-asset-cdn.ecovation.vn/website/seo_banners/hubadmin_seo_banner_1200_630.png',
  ogType: 'article',
};

export const DEFAULT_BANNER =
  'https://public-asset-cdn.ecovation.vn/master/brand/v3/default_banner.webp';
export const DEFAULT_LOGO_SKELETON =
  'https://public-asset-cdn.ecovation.vn/master/brand/v3/default_image.webp';

export const DEFAULT_VIETQR_LOGO =
  'https://public-asset-cdn.ecovation.vn/master/logo/bank/viet-qr-icon.png';
export const DEFAULT_VIETQR_TITLE =
  'https://public-asset-cdn.ecovation.vn/master/logo/bank/vietqr-title-100.png';
export const DEFAULT_NAPAS_TITLE =
  'https://public-asset-cdn.ecovation.vn/master/logo/bank/napas247-icon.png';
export const LARK_APP_ICON =
  'https://public-asset-cdn.ecovation.vn/master/app/larksuit_logo_512_512.png';
export const LARK_FULL_LOGO_ICON =
  'https://public-asset-cdn.ecovation.vn/master/app/larksuit_logo_512_512.png';

export const MAX_ADDRESS_AMOUNT = 50;
export const DEFAULT_WIDTH = '1200px';
export const DEFAULT_WIDTH_AS_NUMBER = 1200;

export const CHECK_DOMAIN = ['ecomend.ai', 'check.demo.ecovation.vn', 'check.bactom.ecovation.vn', 'check.'];
export const isCheckDomain = () =>
  CHECK_DOMAIN.some(domain => window.location.host.includes(domain));

export const TRADE_DOMAIN = ['trade.demo.ecovation.vn', 'trade.bactom.ecovation.vn', 'trade.'];
export const isTradeDomain = () =>
  TRADE_DOMAIN.some(domain => window.location.host.includes(domain));

export const SUPPLY_DOMAIN = ['supply.demo.ecovation.vn', 'supply.bactom.ecovation.vn', 'supply.', 'localhost'];
export const isSupplyDomain = () =>
  SUPPLY_DOMAIN.some(domain => window.location.host.includes(domain));

export const getAppTypeByDomain = (): number => {
  if (isCheckDomain()) return APP_TYPE.CHECK_ADMIN;
  if (isSupplyDomain()) return APP_TYPE.SUPPLY_ADMIN;
  return APP_TYPE.TRADE_ADMIN;
};

export const LANDLINE_REGEX = /((^(\+84|84|0){1})(2([0-9]{1,2})))+([0-9]{8})$/;
export const CELLPHONE_REGEX = /((^(\+84|84|0){1})([0-9]{1,2}))+([0-9]{8})$/;
export const VIETNAM_PHONE_REGEX = /^(03|05|07|08|09)+([0-9]{8})\b/;

export const FARM_DETAIL_REGEX =
  /^\/farm\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?:\/.*)?$/i;

export const STORE_DETAIL_REGEX =
  /^\/store\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?:\/.*)?$/i;

export const COLLABORATOR_DETAIL_REGEX =
  /^\/collaborator\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?:\/.*)?$/i;

export const TAX_CODE_REGEX = /^([0-9]{10}-[0-9]{3})$|^([0-9]{10})$/;

export const MAX_LENGTH_SHORT_ID = 7;
export const MIN_LENGTH_SHORT_ID = 5;
export const LENGTH_COMMON_SHORT_ID = 5;
export const MAX_LENGTH_SKU_NUMBER = 20;
export const MAX_LENGTH_SKU_CHAR = 10;
export const ROUND_INVENTORY_QUANTITY = 3;

export const PRIMARY_COLOR = `#26B75D`;

export const APP_TYPE = {
  TRADE_ADMIN: 1,
  CHECK: 2,
  BILLING: 3,
  IDENTITY: 4,
  STORE: 5,
  FARM: 6,
  COLLABORATOR: 7,
  CHECK_ADMIN: 15,
  SUPPLY_ADMIN: 14,
  GROW_ADMIN: 16,
};

export const SHORT_ID_REGEX = new RegExp(
  `^[A-Z0-9]{${MIN_LENGTH_SHORT_ID},${MAX_LENGTH_SHORT_ID}}$`
);

export const COUPON_REGEX = /^[a-zA-Z0-9]{5,20}$/;

export enum DIGITAL_MENU_SORT_TYPE {
  DEFAULT = 0,
  SIMILARITY = 1,
  ALPHABET = 2,
  CREATED_AT = 3,
  SKU = 4,
}

export const CELLPHONE_CHARS = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  ' ',
];
export const ORDER_NOTE_MAX_LENGTH = 300;
export const NOTE_MAX_LENGTH = 300;
export const NOTE_ITEM_MAX_LENGTH = 100;
export const ORDER_NOTE_ITEM_MAX_LENGTH = 100;

export const FORMAT_DATE = 'DD/MM/yyyy';
export const FORMAT_MONTH = 'MM/yyyy';
export const FORMAT_YEAR = 'yyyy';
export const FORMAT_TIME = 'HH:mm DD/MM/yyyy';

export enum DAY_PICKER_OPTION {
  TO_DAY = 'TO_DAY',
  THIS_WEEK = 'THIS_WEEK',
  YESTERDAY = 'YESTERDAY',
  TWO_DAY = 'TWO_DAY',
  SEVEN_DAY = 'SEVEN_DAY',
  ONE_MONTH = 'ONE_MONTH',
  BY_DAY = 'BY_DAY',
  BY_WEEK = 'BY_WEEK',
  BY_MONTH = 'BY_MONTH',
  BY_YEAR = 'BY_YEAR',
  RANGE_TIME = 'RANGE_TIME',
}

export const TIME_GROUP_TYPE = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
  YEAR: 'year',
};

export enum VN_DAY {
  Monday = 'Thứ 2',
  Tuesday = 'Thứ 3',
  Wednesday = 'Thứ 4',
  Thursday = 'Thứ 5',
  Friday = 'Thứ 6',
  Saturday = 'Thứ 7',
  Sunday = 'Chủ nhật',
}

export const initTodayStateTimeActive = {
  title: 'Hôm nay',
  content: `${moment().format(FORMAT_DATE)}`,
  type: DAY_PICKER_OPTION.TO_DAY,
  startedAt: moment().startOf('day'),
  finishedAt: moment().endOf('day'),
};

export const initThisMonthStateTimeActive = {
  title: 'Tháng này',
  content: `${moment().format(FORMAT_MONTH)} `,
  type: DAY_PICKER_OPTION.BY_MONTH,
  startedAt: moment().startOf('month'),
  finishedAt: moment().endOf('month'),
};

export const PROPOSAL_POLICY_EXAMPLE_GOOGLE_SHEET =
  'https://docs.google.com/spreadsheets/d/1UcouiH4qR89dcetcAImV37wf9GhXwJhEK_ac8ZtUZ2U/edit?usp=sharing';

export const PROPOSAL_POLICY_EXAMPLE_FILE =
  'https://public-asset-cdn.ecovation.vn/master/example-files/example_proposal_policy_file.csv';

export const PRICE_POLICY_EXAMPLE_GOOGLE_SHEET =
  'https://docs.google.com/spreadsheets/d/1SS7AAXoSfzcfb5o6-A7Oj-vuviT_UYJBs2lpNp7MmG0/edit#gid=693805805';

export const PRICE_POLICY_EXAMPLE_FILE =
  'https://public-asset-cdn.ecovation.vn/master/example-files/example_price_policy_file.csv';

export const ENTITY_PRODUCT_EXAMPLE_GOOGLE_SHEET =
  'https://docs.google.com/spreadsheets/d/1HmHoSlyXOt_NSauDHlYdu-uIC9cJzVrqaOga-_sp2fY/edit#gid=533989944';

export const ENTITY_PRODUCT_EXAMPLE_FILE =
  'https://public-asset-cdn.ecovation.vn/master/example-files/example_entity_product_file.xlsx';

export const IMPORT_UPLOAD_ACCEPT =
  '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

export const HARDCODE_OTP_UUID = 'f499bf02-432d-11ed-b878-0242ac120002';

export const DEFAULT_WEBSITE_NAME = `WEBSITE`;

export const LOGO_QR_CODE =
  'https://public-asset-cdn.ecovation.vn/master/brand/v3/default_image.webp';

export const LOGO =
  'https://public-asset-cdn.ecovation.vn/master/brand/v3/default_image.webp';

export const DEFAULT_LOGO_SKELETON_THUMBNAIL =
  'https://public-asset-cdn.ecovation.vn/master/brand/v3/default_image.webp';

export const COLLABORATOR_TEXT = {
  ABBREVIATION: 'ĐSBH',
  CAPITALIZE: 'Đại sứ bán hàng',
  LOWERCASE: 'đại sứ bán hàng',
  UPPERCASE: 'ĐẠI SỨ BÁN HÀNG',
};

export const STATE_ACTION = {
  ADD: 0,
  REMOVE: 1,
  REPLACE: 2,
};

export const PRODUCT_STATUS = {
  ALL: -1,
  ACTIVATED: 0,
  DEACTIVATED: 1,
  PENDING: 2,
  REJECT: 3,
};

export const SECTION_STATUS = {
  ACTIVATED: 0,
  DEACTIVATED: 1,
};

export const CATEGORY_STATUS = {
  ACTIVATED: 0,
  DEACTIVATED: 1,
  PENDING: 2,
  DRAFTED: 3,
};

export const ENTITY_STATUS = {
  ACTIVATED: 0,
  DEACTIVATED: 1,
  PENDING: 2,
  REJECT: 3,
};

export const CONNECT_ROLE = {
  SUPPLIER: 0,
  CUSTOMER: 1,
};

export const INVITATION_TYPE = {
  CONNECT_ENTITY: 0,
  SYNC_PRODUCT: 1,
  SYNC_PRODUCT_DIARIES: 2,
};

export const OPTION_TYPE = {
  PRODUCT: 0,
  ORDER: 1,
  ENTITY: 2,
};

export const OPTION_TYPE_STRING = {
  PRODUCT: {
    en: 'PRODUCT',
    vi: 'Sản phẩm',
  },
  ORDER: {
    en: 'ORDER',
    vi: 'Đơn hàng',
  },
  ENTITY: {
    en: 'ENTITY',
    vi: 'Thực thể',
  },
};

export const INVITATION_STATUS = {
  PENDING: 0,
  SUGGESTION: 1,
  ACCEPT: 2,
  DENIED: 3,
  PENDING_SYNC: 4,
};

export const GROUP_TYPE = {
  SUPPLIER: 0,
  CUSTOMER: 1,
};

export const COUPON_STATUS = {
  ACTIVATED: 0,
  DEACTIVATED: 1,
  UPCOMING: 2,
  DISPLAYING: 3,
};

export const COMBO_TYPE = {
  PERCENT: 0,
  PRICE: 1,
  SPECIAL: 2,
};

export const COMBO_STATUS = {
  ALL: -1,
  ACTIVATED: 0,
  DEACTIVATED: 1,
  UPCOMING: 2,
};

export const DISCOUNT_STATUS = {
  ALL: -1,
  ACTIVATED: 0,
  DEACTIVATED: 1,
  UPCOMING: 2,
};

export const COMBO_PRODUCT_STATUS = {
  ACTIVATED: 0,
  DEACTIVATED: 1,
};

export const ERROR_CENSORSHIP_TYPE = {
  ENTITY: 0,
  PRODUCT: 1,
};

export const PRODUCT_OBJECT_TYPE = {
  FIELD: 0,
  FARMING: 1,
  PRODUCTION: 2,
};

export enum ORDER_DELIVERY_METHOD {
  PLATFORM_DELIVERY = 0,
  RECEIVE_ON_STORE = 1,
}

export const STEP_TYPE = {
  TEXT: 0,
  NUMBER: 1,
  LINK: 2,
};

export const DEFAULT_ORDER_DELIVERY_METHOD =
  ORDER_DELIVERY_METHOD.PLATFORM_DELIVERY;

export enum ORDER_PAYMENT_METHOD {
  CASH = 0,
  E_WALLET = 1,
  INTERNET_BANKING = 2,
  CREDIT_CARD = 3,
  DEBT = 4,
}

export const DEFAULT_ORDER_PAYMENT_METHOD = ORDER_PAYMENT_METHOD.CASH;

export enum BILL_PAYMENT_METHOD {
  CASH = 0,
  E_WALLET = 1,
  INTERNET_BANKING = 2,
  CREDIT_CARD = 3,
}

export const BILL_PAYMENT_METHOD_TEXT = {
  [BILL_PAYMENT_METHOD.CASH]: 'Thanh toán khi nhận hàng',
  [BILL_PAYMENT_METHOD.E_WALLET]: 'Thanh toán bằng ví điện tử',
  [BILL_PAYMENT_METHOD.INTERNET_BANKING]:
    'Thanh toán thông qua tài khoản ngân hàng',
  [BILL_PAYMENT_METHOD.CREDIT_CARD]:
    'Thanh toán bằng thẻ quốc tế Visa, Master, JCB',
};

export const DEFAULT_BILL_PAYMENT_METHOD = BILL_PAYMENT_METHOD.CASH;

export enum BILL_DELIVERY_METHOD {
  PLATFORM_DELIVERY = 0,
  RECEIVE_ON_STORE = 1,
}

export const DEFAULT_BILL_DELIVERY_METHOD =
  BILL_DELIVERY_METHOD.PLATFORM_DELIVERY;

export enum BILL_PAID_MONEY {
  CASH = 'cash',
  E_WALLET = 'eWallet',
  INTERNET_BANKING = 'internetBanking',
  CREDIT_CARD = 'creditCard',
}

export const BILL_PAID_MONEY_TEXT = {
  [BILL_PAID_MONEY.CASH]: 'Tiền mặt',
  [BILL_PAID_MONEY.E_WALLET]: 'Ví điện tử',
  [BILL_PAID_MONEY.INTERNET_BANKING]: 'Chuyển khoản',
  [BILL_PAID_MONEY.CREDIT_CARD]: 'Ngân hàng',
};

export const ORDER_ACTION = {
  SUPPLIER_CONFIRM_OR_COMPLETE: 'Xác nhận đơn',
  CUSTOMER_CONFIRM: 'Hoàn thành',
  // TODO: refactor, move all action name here
};

export const MENU_TITLE_ORDER_BY_STATUS = {
  PENDING: 'Soạn hàng',
  // SELF_CONFIRM: 'Chờ bạn xác nhận',
  // CONFIRM: 'Chờ KH xác nhận',
  // SELF_SUPPLIER_CONFIRM: 'Chờ bạn xác nhận',
  // SUPPLIER_CONFIRM: 'Chờ NCC xác nhận',
  SELF_CONFIRM: 'Kiểm hàng',
  CONFIRM: 'Kiểm hàng',
  SELF_SUPPLIER_CONFIRM: 'Kiểm hàng',
  SUPPLIER_CONFIRM: 'Kiểm hàng',
  PROCESSING: 'Đóng gói',
  COMPLETE: 'Hoàn thành',
  DELIVERY: 'Giao hàng',
  REJECT: 'Đã hủy',
  CUSTOMER_DRAFT: 'Bản nháp KH',
  SUPPLIER_DRAFT: 'Bản nháp NCC',
  PRE_PROCESSING: 'Tiền xử lý',
  PENDING_EXECUTE: 'Nhận đơn',
  ADDITIONAL_ORDER: 'Đơn bổ sung',
  MERGED: 'Đơn đã gộp',
};

export const CO_BUY_STATUS = {
  ACTIVATED: 0, // approved (upcoming or inprogress)
  DEACTIVATED: 1, // done
  UP_COMMING: 2,
  DRAFTED: 3,
  PENDING: 4, // pending approve by supplier
};

export const ORDER_DELIVERY_METHOD_TEXT: { [key: number]: string } = {
  [ORDER_DELIVERY_METHOD.PLATFORM_DELIVERY]: 'Giao hàng tiêu chuẩn',
  [ORDER_DELIVERY_METHOD.RECEIVE_ON_STORE]: 'Nhận tại cửa hàng',
};

export const ORDER_PAYMENT_METHOD_TEXT: { [key: number]: string } = {
  [ORDER_PAYMENT_METHOD.CASH]: 'Thanh toán khi nhận hàng',
  [ORDER_PAYMENT_METHOD.E_WALLET]: 'Thanh toán bằng ví điện tử',
  [ORDER_PAYMENT_METHOD.INTERNET_BANKING]:
    'Thanh toán bằng tài khoản ngân hàng',
  [ORDER_PAYMENT_METHOD.CREDIT_CARD]:
    'Thanh toán bằng thẻ quốc tế Visa, Master, JCB',
  [ORDER_PAYMENT_METHOD.DEBT]: 'Ghi vào công nợ',
};

export const DOMAIN_STATUS = {
  ACTIVATE: 0,
  DEACTIVATE: 1,
  WAITING_FOR_APPROVAL: 2,
  WAITING_FOR_APPROVAL_AND_SUPPORT: 3,
};

export const ENTITY_TYPE = {
  ALL: -1,
  USER: 0,
  FARM: 1,
  STORE: 2,
  COLLABORATOR: 3,
  WAREHOUSE: 4,
  TRANSPORT: 5,
  VOLUNTEER: 6,
};

export enum SEARCH_RESULT_CONNECT_TYPE {
  NOT_CONNECT = 1,
  INVITED = 2,
  CONNECTED = 0,
}

export const ENTITY_OBJECT_TYPE = {
  DEFAULT: 0,
  CO_OPERATIVE: 1,
  ENTERPRISE: 2,
  // Các thực thể có domain vừa gắn với farm vừa gắn với admin dùng cho cả CO_OPERATIVE và ENTERPRISE
  ENTITY_CONNECT_CHAIN_ENTITY: 3,
};

export enum ORDER_ACTION_ENUM {
  CREATE_ORDER = 'CREATE_ORDER',
  CREATE_DRAFT_ORDER = 'CREATE_DRAFT_ORDER',
  CREATE_ADDITIONAL_ORDER = 'CREATE_ADDITIONAL_ORDER',
  MERGE_ORDER = 'MERGE_ORDER',
  FORWARD_ORDER = 'FORWARD_ORDER',
  UPDATE_STATUS_PENDING = 'UPDATE_STATUS_PENDING',
  UPDATE_STATUS_PROCESSING = 'UPDATE_STATUS_PROCESSING',
  UPDATE_STATUS_DELIVERY = 'CONFIRM_AMOUNT_DELIVERED',
  UPDATE_STATUS_CONFIRM = 'UPDATE_STATUS_CONFIRM',
  UPDATE_STATUS_SUPPLIER_CONFIRM = 'CONFIRM_AMOUNT_RECEIVED',
  UPDATE_STATUS_COMPLETE = 'UPDATE_STATUS_COMPLETE',
  UPDATE_STATUS_REJECT = 'UPDATE_STATUS_REJECT',
  UPDATE_STATUS_DRAFT = 'UPDATE_STATUS_DRAFT',
  UPDATE_STATUS_SUPPLIER_DRAFT = 'UPDATE_STATUS_SUPPLIER_DRAFT',
  UPDATE_STATUS_PENDING_EXECUTE = 'UPDATE_STATUS_PENDING_EXECUTE',
  UPDATE_STATUS_PRE_PROCESSING = 'UPDATE_STATUS_PRE_PROCESSING',
  UPDATE_STATUS_MERGED = 'UPDATE_STATUS_MERGED',
  PAYMENT_COMPLETE = 'PAYMENT_COMPLETE',
  UPDATE_ORDER_BY_SUPPLIER = 'UPDATE_ORDER_BY_SUPPLIER',
  UPDATE_ORDER_CUSTOMER_NOTE = 'UPDATE_ORDER_CUSTOMER_NOTE',
  UPDATE_ORDER_SUPPLIER_NOTE = 'UPDATE_ORDER_SUPPLIER_NOTE',
  UPDATE_ORDER_ITEM_CUSTOMER_NOTE = 'UPDATE_ORDER_SUPPLIER_NOTE',
  UPDATE_ORDER_ITEM_SUPPLIER_NOTE = 'UPDATE_ORDER_ITEM_SUPPLIER_NOTE',
  DELETE_ORDER_ITEM = 'DELETE_ORDER_ITEM',
  ADD_ORDER_ITEM = 'ADD_ORDER_ITEM',
  UPDATE_ORDER_ITEM_QUANTITY = 'UPDATE_ORDER_ITEM_QUANTITY',
  UPDATE_ORDER_ITEM_QUANTITY_DELIVERED = 'UPDATE_ORDER_ITEM_QUANTITY_DELIVERED',
  UPDATE_ADDRESS = 'UPDATE_ADDRESS',
  UPDATE_DELIVERY_METHOD = 'UPDATE_DELIVERY_METHOD',
  UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD',
  DELETE_ENTITY = 'DELETE_ENTITY',
  DELETE_PRODUCT = 'DELETE_PRODUCT',
}

export enum USER_ROLE {
  OWNER = 'owner',
  MANAGER = 'manager',
  EMPLOYEE = 'employee',
  CUSTOMER = 'customer',
  SYSTEM_ADMIN = 'system_admin',
}

export const ORDER_ENTITY_ROLE = {
  SUPPLIER_CENTRAL: 'supplier_central',
  CUSTOMER_CENTRAL: 'customer_central',
  SUPPLIER_CENTRAL_STAFF: 'supplier_central_staff',
  SUPPLIER_CENTRAL_MANAGER: 'supplier_central_manager',
  CUSTOMER_CENTRAL_STAFF: 'customer_central_staff',
  CUSTOMER_CENTRAL_MANAGER: 'customer_central_manager',

  OWNER: 'owner',
  CUSTOMER: 'customer',
  SUPPLIER: 'supplier',
  COLLABORATOR: 'collaborator',

  SUPPLIER_STAFF: 'supplier_staff',
  SUPPLIER_MANAGER: 'supplier_manager',
  CUSTOMER_STAFF: 'customer_staff',
  CUSTOMER_MANAGER: 'customer_manager',

  ORDER_SUPPLIER_ASSIGNEE: 'order_supplier_assignee',
  ORDER_CUSTOMER_ASSIGNEE: 'order_customer_assignee',

  SYSTEM_ADMIN: 'system_admin',

  // old role version
  MANAGER: 'manager',
  EMPLOYEE: 'employee',
};

export const OPTION_VALUE_ALL = 'all';

export const REPORT_TYPE = {
  RELATIVE: 0,
  ABSOLUTE: 1,
  EMPTY: 2,
};

export enum ORDER_TYPE {
  ALL = -1,
  WHOLESALE = 0,
  RETAIL = 1,
  CO_BUY = 2,
  DIGITAL_MENU = 3,
  WHOLESALE_DIGITAL_MENU = 4,
}

export const FILTER_SETTING_BALANCE_TABLE = 'filter_balance_table';
export const FILTER_SETTING_PURCHASE_TABLE = 'filter_purchase_table';
export const FILTER_SETTING_PRODUCT_REPORT_QUANTITY_TABLE =
  'filter_setting_product_report_quantity_balance_table';
export const RESET_RECEIVED_QUANTITY_AT_CENTRAL =
  'reset_received_quantity_at_central';

export enum FILTER_QUANTITY_TYPE {
  CUSTOMER_ORDER_QUANTITY = 0,
  ESTIMATED_QUANTITY = 1,
  QUANTITY = 2,
  ORDER_TO_SUPPLIER_QUANTITY = 3,
  SUPPLIER_DELIVERED_QUANTITY = 4,
  SUPPLIER_PROCESSED_QUANTITY = 5,
  SUPPLIER_RECEIVED_QUANTITY = 6,
  MISSING_OR_REDUNDANT_ESTIMATED_QUANTITY = 7,
  MISSING_OR_REDUNDANT_CUSTOMER_QUANTITY = 8,
}

export const FILTER_QUANTITY_TYPE_NAME = {
  [FILTER_QUANTITY_TYPE.CUSTOMER_ORDER_QUANTITY]: 'customerOrderQuantity',
  [FILTER_QUANTITY_TYPE.ESTIMATED_QUANTITY]: 'estimatedQuantity',
  [FILTER_QUANTITY_TYPE.QUANTITY]: 'quantity',
  [FILTER_QUANTITY_TYPE.ORDER_TO_SUPPLIER_QUANTITY]: 'orderToSupplierQuantity',
  [FILTER_QUANTITY_TYPE.SUPPLIER_DELIVERED_QUANTITY]:
    'supplierDeliveredQuantity',
  [FILTER_QUANTITY_TYPE.SUPPLIER_PROCESSED_QUANTITY]:
    'supplierProcessedQuantity',
  [FILTER_QUANTITY_TYPE.SUPPLIER_RECEIVED_QUANTITY]: 'supplierReceivedQuantity',
  [FILTER_QUANTITY_TYPE.MISSING_OR_REDUNDANT_ESTIMATED_QUANTITY]:
    'missingOrRedundantEstimatedQuantity',
  [FILTER_QUANTITY_TYPE.MISSING_OR_REDUNDANT_CUSTOMER_QUANTITY]:
    'missingOrRedundantCustomerOrderQuantity',
};

export const FILTER_QUANTITY_TYPE_TEXT = {
  [FILTER_QUANTITY_TYPE.CUSTOMER_ORDER_QUANTITY]: 'Số lượng đặt',
  [FILTER_QUANTITY_TYPE.ESTIMATED_QUANTITY]: 'Số lượng báo',
  [FILTER_QUANTITY_TYPE.QUANTITY]: 'Số lượng thực',
  [FILTER_QUANTITY_TYPE.ORDER_TO_SUPPLIER_QUANTITY]: 'Số lượng đặt vườn',
  [FILTER_QUANTITY_TYPE.SUPPLIER_RECEIVED_QUANTITY]: 'Số lượng nhận',
  [FILTER_QUANTITY_TYPE.SUPPLIER_DELIVERED_QUANTITY]: 'Số lượng vườn giao',
  [FILTER_QUANTITY_TYPE.SUPPLIER_PROCESSED_QUANTITY]: 'Số lượng sơ chế',
};

export enum FILTER_TYPE {
  MULTI = 0,
  SINGLE = 1,
}

export enum FILTER_CONTROL_TYPE {
  PANEL = 0,
  SWITCH = 1,
  PANEL_SWITCH = 2,
}

export enum FILTER_BALANCE_QUANTITY_TYPE {
  HAS_QUANTITY = 1,
  NO_QUANTITY = 0,
}

export enum FILTER_PURCHASE_QUANTITY_TYPE {
  HAS_QUANTITY = 4,
  NO_QUANTITY = 0,
}

export enum FILTER_STOCK_TYPE {
  ENOUGH = 2, // đủ hàng
  MISSING = 3, // thiếu hàng
  REDUNDANT = 4, // thừa hàng
}

// Order Setting Balance

export interface OrderSettingBalance {
  viewMode: SETTING_VIEW_MODE;
  orderType: SETTING_ORDER_TYPE;
  orderTime: SETTING_ORDER_TIME;
  quantityDisplay: SETTING_QUANTITY_DISPLAY;
  branchDisplay: SETTING_BRANCH_DISPLAY;
}

export interface SETTING_BRANCH_DISPLAY {
  branchDisplay: string[];
  default: string[];
  visible: boolean;
}

export interface SETTING_VIEW_MODE {
  viewModeType: SETTING_VIEW_MODE_TYPE[];
  default: SETTING_VIEW_MODE_TYPE;
  visible: boolean;
}

export interface SETTING_ORDER_TYPE {
  orderType: ORDER_TYPE[];
  default: ORDER_TYPE;
  visible: boolean;
}

export interface SETTING_ORDER_TIME {
  orderTime: SETTING_ORDER_TIME_TYPE[];
  default: SETTING_ORDER_TIME_TYPE;
  visible: boolean;
}

export interface SETTING_QUANTITY_DISPLAY {
  quantityDisplay: SETTING_QUANTITY_DISPLAY_TYPE[];
  default: SETTING_QUANTITY_DISPLAY_TYPE;
  visible: boolean;
}

export enum SETTING_ORDER_TIME_TYPE {
  ALL = 0,
  TODAY = 1,
}

export enum SETTING_VIEW_MODE_TYPE {
  ORDER = 0,
  CUSTOMER = 1,
}

export enum SETTING_QUANTITY_DISPLAY_TYPE {
  CUSTOMER_QUANTITY = 0,
  SUPPLIER_QUANTITY = 1,
}

export const INIT_SETTING_BRANCH_DISPLAY = {
  branchDisplay: ['-1'],
  default: ['-1'],
  visible: false,
};

export const INIT_SETTING_VIEW_MODE = {
  viewModeType: [SETTING_VIEW_MODE_TYPE.ORDER, SETTING_VIEW_MODE_TYPE.CUSTOMER],
  default: SETTING_VIEW_MODE_TYPE.ORDER,
  visible: true,
};

export const INIT_SETTING_ORDER_TIME = {
  orderTime: [SETTING_ORDER_TIME_TYPE.ALL, SETTING_ORDER_TIME_TYPE.TODAY],
  default: SETTING_ORDER_TIME_TYPE.ALL,
  visible: false,
};

export const INIT_SETTING_ORDER_TYPE = {
  orderType: [
    ORDER_TYPE.ALL,
    ORDER_TYPE.CO_BUY,
    ORDER_TYPE.RETAIL,
    ORDER_TYPE.WHOLESALE,
    ORDER_TYPE.DIGITAL_MENU,
    ORDER_TYPE.WHOLESALE_DIGITAL_MENU,
  ],
  default: ORDER_TYPE.ALL,
  visible: false,
};

export const INIT_SETTING_QUANTITY_DISPLAY = {
  quantityDisplay: [
    SETTING_QUANTITY_DISPLAY_TYPE.CUSTOMER_QUANTITY,
    SETTING_QUANTITY_DISPLAY_TYPE.SUPPLIER_QUANTITY,
  ],
  default: SETTING_QUANTITY_DISPLAY_TYPE.CUSTOMER_QUANTITY,
  visible: true,
};

export const INIT_ORDER_SETTING_BALANCE = {
  viewMode: INIT_SETTING_VIEW_MODE,
  orderType: INIT_SETTING_ORDER_TYPE,
  orderTime: INIT_SETTING_ORDER_TIME,
  quantityDisplay: INIT_SETTING_QUANTITY_DISPLAY,
  branchDisplay: INIT_SETTING_BRANCH_DISPLAY,
};

// Product Setting Balance

export interface ProductSettingBalance {
  categoryDisplay: SETTING_CATEGORY_DISPLAY;
  sort: SETTING_SORT;
}

export interface ProductSettingExport {
  categoryDisplay: SETTING_CATEGORY_DISPLAY;
  sort: SETTING_SORT;
  columnDisplay: SETTING_COLUMN_DISPLAY;
  informationDisplay: SETTING_INFORMATION_DISPLAY;
  K80OrderInfoDisplay: SETTING_K80_ORDER_INFO_DISPLAY;
  K80QuantityDisplay: SETTING_K80_QUANTITY_DISPLAY;
}

export interface BillSettingExport {
  billInfoDisplay: SETTING_BILL_INFO_DISPLAY;
}

export interface ShippingListSetting {
  columnDisplay: SETTING_COLUMN_DISPLAY;
}

export interface SETTING_CATEGORY_DISPLAY {
  categoryDisplay: string[];
  default: string[];
  visible: boolean;
}

export interface SETTING_BILL_INFO_DISPLAY {
  billInfoDisplay: { [column: string]: boolean };
  default: { [column: string]: boolean };
  visible: boolean;
}

export interface SETTING_K80_ORDER_INFO_DISPLAY {
  orderInfoDisplay: { [column: string]: boolean };
  default: { [column: string]: boolean };
  visible: boolean;
}

export interface SETTING_K80_QUANTITY_DISPLAY {
  quantityDisplay: { [column: string]: boolean };
  default: { [column: string]: boolean };
  visible: boolean;
}

export interface SETTING_COLUMN_DISPLAY {
  columnDisplay: { [column: string]: boolean };
  default: { [column: string]: boolean };
  visible: boolean;
}

export interface SETTING_INFORMATION_DISPLAY {
  informationDisplay: { [column: string]: boolean };
  default: { [column: string]: boolean };
  visible: boolean;
}

export interface SETTING_SORT {
  sortType: SETTING_SORT_TYPE[];
  default: SETTING_SORT_TYPE;
  visible: boolean;
}

export enum SETTING_SORT_TYPE {
  CREATED_AT = 0,
  ALPHABET = 1,
  SKU = 2,
  SIMILAR = 3,
}

export const DATA_SETTING_SORT = {
  [SETTING_SORT_TYPE.CREATED_AT]: {
    createdAt: 0,
  },
  [SETTING_SORT_TYPE.ALPHABET]: {
    name: 0,
  },
  [SETTING_SORT_TYPE.SKU]: {
    sku: 0,
  },
  [SETTING_SORT_TYPE.SIMILAR]: {
    similarity: 0,
  },
};

export const INIT_SETTING_SORT = {
  sortType: [
    SETTING_SORT_TYPE.CREATED_AT,
    SETTING_SORT_TYPE.ALPHABET,
    SETTING_SORT_TYPE.SKU,
    SETTING_SORT_TYPE.SIMILAR,
  ],
  default: SETTING_SORT_TYPE.SKU,
  visible: true,
};

export const INIT_SETTING_CATEGORY_DISPLAY = {
  categoryDisplay: ['-1'],
  default: ['-1'],
  visible: true,
};

export const CUSTOMER_GENDER = [
  {
    value: 0,
    label: 'Khác',
  },
  {
    value: 1,
    label: 'Nam',
  },
  {
    value: 2,
    label: 'Nữ',
  },
];

export const INIT_SETTING_COLUMN_DISPLAY = {
  columnDisplay: {},
  default: { PromotionPrice: true, TotalPrice: true },
  visible: true,
};

export const INIT_SHIPPING_LIST_SETTING_COLUMN_DISPLAY = {
  columnDisplay: {},
  default: {
    isVisibleOrderCode: true,
    isVisibleOrderQRCode: false,
    isVisibleCustomerCode: true,
    isVisibleCustomerName: true,
    isVisibleCustomerPhoneNumber: true,
    isVisibleCustomerAddress: true,
    isVisibleCustomerDistrict: true,
    isVisibleShippingCode: true,
    isVisibleShippingAmount: true,
    isVisibleShippingQuantity: true,
    isVisibleShippingFee: true,
    isVisibleShippingNote: true,
  },
  visible: true,
};

export const INIT_SETTING_INFORMATION_DISPLAY = {
  informationDisplay: {},
  default: {
    Category: true,
  },
  visible: true,
};

export const INIT_BILL_INFO_DISPLAY = {
  billInfoDisplay: {},
  default: {
    isVisibleLogo: true,
    isVisiblePaymentQRCode: true,
    isVisiblePaymentInfo: true,
    isVisibleDeliveryFee: true,
    isVisibleDeliveryFeeWhenEmpty: false,
    isVisiblePriceDetail: true,
    isVisibleCustomer: true,
    isVisibleCustomerPhoneNumber: true,
    isVisibleCustomerAddress: true,
    isVisibleSupplier: true,
    isVisibleSupplierPhoneNumber: true,
    isVisibleSupplierAddress: true,
    isVisibleSupplierCashier: true,
    isVisibleSignature: true,
  },
  visible: true,
};

export const INIT_SETTING_K80_QUANTITY_DISPLAY = {
  quantityDisplay: {},
  default: {
    isVisibleCustomerQuantity: true,
    isVisibleSupplierQuantity: true,
    isVisibleSupplierDelivered: true,
    isVisibleCustomerReceived: true,
  },
  visible: true,
};

export const INIT_SETTING_K80_ORDER_INFO_DISPLAY = {
  orderInfoDisplay: {},
  default: {
    isCentral: true,
    isSupplier: false,
    isAvatar: true,
    isAvatarText: false,
    isVisibleLogo: false,
    isVisibleQRCode: true,
    isVisibleOrderCode: true,
    isVisibleCustomerOrderNote: true,
    isVisibleSupplierOrderNote: true,
    isVisibleCustomer: true,
    isVisibleCustomerName: true,
    isVisibleCustomerPhoneNumber: true,
    isVisibleCustomerAddress: true,
    isVisibleTotalProducts: false,
    isVisibleProduct: true,
    isVisibleProductCategory: true,
    isVisibleProductUnit: true,
    isVisibleProductPrice: true,
    isVisibleCustomerOrderItemNote: true,
    isVisibleSupplierOrderItemNote: true,
  },
  visible: true,
};

export const INIT_PRODUCT_SETTING_BALANCE = {
  categoryDisplay: INIT_SETTING_CATEGORY_DISPLAY,
  sort: INIT_SETTING_SORT,
};

export const INIT_PRODUCT_SETTING_EXPORT = {
  categoryDisplay: INIT_SETTING_CATEGORY_DISPLAY,
  sort: INIT_SETTING_SORT,
  columnDisplay: INIT_SETTING_COLUMN_DISPLAY,
  informationDisplay: INIT_SETTING_INFORMATION_DISPLAY,
  K80QuantityDisplay: INIT_SETTING_K80_QUANTITY_DISPLAY,
  K80OrderInfoDisplay: INIT_SETTING_K80_ORDER_INFO_DISPLAY,
};

export const INIT_BILL_SETTING_EXPORT = {
  billInfoDisplay: INIT_BILL_INFO_DISPLAY,
};

export const INIT_SHIPPING_LIST_SETTING = {
  columnDisplay: INIT_SHIPPING_LIST_SETTING_COLUMN_DISPLAY,
};

// REPORT QUANTITY SETTING
// Product setting product report quantity

export interface ProductSettingProductReportQuantity {
  categoryDisplay: SETTING_CATEGORY_DISPLAY;
  sort: SETTING_SORT;
}

export const INIT_PRODUCT_SETTING_PRODUCT_REPORT_QUANTITY = {
  categoryDisplay: INIT_SETTING_CATEGORY_DISPLAY,
  sort: INIT_SETTING_SORT,
};

// Display Setting Balance

export interface DisplaySettingBalance {
  customerQuantity: SETTING_CUSTOMER_QUANTITY_DISPLAY;
  mergeMultiOrderCustomer: SETTING_MERGE_MULTI_ORDER_CUSTOMER_DISPLAY;
  updateMultiOrderStatus: SETTING_UPDATE_MULTI_ORDER_STATUS_DISPLAY;
  totalCustomerOrderQuantity: SETTING_TOTAL_ONWAY_DISPLAY;
  totalReceivedQuantity: SETTING_TOTAL_ONWAY_DISPLAY;
  totalSupplierQuantity: SETTING_TOTAL_ONWAY_DISPLAY;
  totalMissingOrRedundantReceivedQuantity: SETTING_TOTAL_ONWAY_DISPLAY;
  totalOnway: SETTING_TOTAL_ONWAY_DISPLAY;
  totalIncoming: SETTING_TOTAL_INCOMING_DISPLAY;
  totalOnHand: SETTING_TOTAL_ON_HAND_DISPLAY;
}

export interface SETTING_CUSTOMER_QUANTITY_DISPLAY {
  visible: boolean;
}

export interface SETTING_MERGE_MULTI_ORDER_CUSTOMER_DISPLAY {
  visible: boolean;
}

export interface SETTING_UPDATE_MULTI_ORDER_STATUS_DISPLAY {
  visible: boolean;
}

export interface SETTING_TOTAL_INCOMING_DISPLAY {
  visible: boolean;
}

export interface SETTING_TOTAL_ON_HAND_DISPLAY {
  visible: boolean;
}

export interface SETTING_TOTAL_ONWAY_DISPLAY {
  visible: boolean;
}

export const INIT_CUSTOMER_QUANTITY_DISPLAY = {
  visible: true,
};

export const INIT_MERGE_MULTI_ORDER_CUSTOMER_DISPLAY = {
  visible: false,
};

export const INIT_UPDATE_MULTI_ORDER_STATUS_DISPLAY = {
  visible: false,
};

export const INIT_TOTAL_CUSTOMER_ORDER_QUANTITY_DISPLAY = {
  visible: true,
};

export const INIT_TOTAL_RECEIVED_QUANTITY_DISPLAY = {
  visible: true,
};

export const INIT_TOTAL_SUPPLIER_QUANTITY_DISPLAY = {
  visible: true,
};

export const INIT_TOTAL_MISSING_OR_REDUNDANT_RECEIVED_QUANTITY_DISPLAY = {
  visible: true,
};

export const INIT_TOTAL_ONWAY_DISPLAY = {
  visible: true,
};

export const INIT_TOTAL_INCOMING_DISPLAY = {
  visible: false,
};

export const INIT_TOTAL_ON_HAND_DISPLAY = {
  visible: false,
};

export const INIT_DISPLAY_SETTING_BALANCE = {
  customerQuantity: INIT_CUSTOMER_QUANTITY_DISPLAY,
  mergeMultiOrderCustomer: INIT_MERGE_MULTI_ORDER_CUSTOMER_DISPLAY,
  updateMultiOrderStatus: INIT_UPDATE_MULTI_ORDER_STATUS_DISPLAY,
  totalCustomerOrderQuantity: INIT_TOTAL_CUSTOMER_ORDER_QUANTITY_DISPLAY,
  totalReceivedQuantity: INIT_TOTAL_RECEIVED_QUANTITY_DISPLAY,
  totalSupplierQuantity: INIT_TOTAL_SUPPLIER_QUANTITY_DISPLAY,
  totalMissingOrRedundantReceivedQuantity:
    INIT_TOTAL_MISSING_OR_REDUNDANT_RECEIVED_QUANTITY_DISPLAY,
  totalOnway: INIT_TOTAL_ONWAY_DISPLAY,
  totalIncoming: INIT_TOTAL_INCOMING_DISPLAY,
  totalOnHand: INIT_TOTAL_ON_HAND_DISPLAY,
};

export enum DISPLAY_SETTING_BALANCE_TEXT {
  customerQuantity = 'Số lượng đặt',
  mergeMultiOrderCustomer = 'Thêm đơn hàng (Tất cả khách hàng)',
  updateMultiOrderStatus = 'Chuyển đơn hàng (Tất cả đơn hàng)',
  totalCustomerOrderQuantity = 'Tổng khách đặt',
  totalReceivedQuantity = 'Tổng thực nhận',
  totalSupplierQuantity = 'Tổng chia tạm',
  totalMissingOrRedundantReceivedQuantity = 'Thiếu dư chia hàng',
  totalIncoming = 'Hàng đang về',
  totalOnHand = 'Tồn kho',
  totalOnway = 'Hàng đang giao',
}

// Display setting product report quantity

export interface PRODUCT_REPORT_QUANTITY_CUSTOMER_ORDER_QUANTITY_DISPLAY {
  visible: boolean;
}
export interface PRODUCT_REPORT_QUANTITY_ESTIMATED_QUANTITY_DISPLAY {
  visible: boolean;
}
export interface PRODUCT_REPORT_QUANTITY_QUANTITY_DISPLAY {
  visible: boolean;
}
export interface PRODUCT_REPORT_QUANTITY_ORDER_TO_SUPPLIER_QUANTITY_DISPLAY {
  visible: boolean;
}
export interface PRODUCT_REPORT_QUANTITY_SUPPLIER_RECEIVED_QUANTITY_DISPLAY {
  visible: boolean;
}
export interface PRODUCT_REPORT_QUANTITY_SUPPLIER_DELIVERED_QUANTITY_DISPLAY {
  visible: boolean;
}
export interface PRODUCT_REPORT_QUANTITY_SUPPLIER_PROCESSED_QUANTITY_DISPLAY {
  visible: boolean;
}
export interface PRODUCT_REPORT_QUANTITY_MISS_OR_REDUNDANT_ESTIMATED_QUANTITY_DISPLAY {
  visible: boolean;
}
export interface PRODUCT_REPORT_QUANTITY_MISS_OR_REDUNDANT_CUSTOMER_QUANTITY_DISPLAY {
  visible: boolean;
}
export interface PRODUCT_REPORT_QUANTITY_TOTAL_MISSING_OR_REDUNDANT_CUSTOMER_QUANTITY_DISPLAY {
  visible: boolean;
}
export interface PRODUCT_REPORT_QUANTITY_TOTAL_MISSING_OR_REDUNDANT_SUPPLIER_QUANTITY_DISPLAY {
  visible: boolean;
}

export interface PRODUCT_REPORT_QUANTITY_TOTAL_CUSTOMER_ORDER_QUANTITY_DISPLAY {
  visible: boolean;
}
export interface PRODUCT_REPORT_QUANTITY_TOTAL_ESTIMATED_QUANTITY_DISPLAY {
  visible: boolean;
}
export interface PRODUCT_REPORT_QUANTITY_TOTAL_QUANTITY_DISPLAY {
  visible: boolean;
}
export interface PRODUCT_REPORT_QUANTITY_TOTAL_ORDER_TO_SUPPLIER_QUANTITY_DISPLAY {
  visible: boolean;
}
export interface PRODUCT_REPORT_QUANTITY_TOTAL_SUPPLIER_RECEIVED_QUANTITY_DISPLAY {
  visible: boolean;
}

export interface PRODUCT_REPORT_QUANTITY_TOTAL_SUPPLIER_DELIVERED_QUANTITY_DISPLAY {
  visible: boolean;
}

export interface PRODUCT_REPORT_QUANTITY_TOTAL_SUPPLIER_PROCESSED_QUANTITY_DISPLAY {
  visible: boolean;
}

export interface DisplaySettingProductReportQuantity {
  customerOrderQuantity: PRODUCT_REPORT_QUANTITY_CUSTOMER_ORDER_QUANTITY_DISPLAY;
  estimatedQuantity: PRODUCT_REPORT_QUANTITY_ESTIMATED_QUANTITY_DISPLAY;
  quantity: PRODUCT_REPORT_QUANTITY_QUANTITY_DISPLAY;
  orderToSupplierQuantity: PRODUCT_REPORT_QUANTITY_ORDER_TO_SUPPLIER_QUANTITY_DISPLAY;
  supplierReceivedQuantity: PRODUCT_REPORT_QUANTITY_SUPPLIER_RECEIVED_QUANTITY_DISPLAY;
  supplierDeliveredQuantity: PRODUCT_REPORT_QUANTITY_SUPPLIER_DELIVERED_QUANTITY_DISPLAY;
  supplierProcessedQuantity: PRODUCT_REPORT_QUANTITY_SUPPLIER_PROCESSED_QUANTITY_DISPLAY;
  missingOrRedundantEstimatedQuantity: PRODUCT_REPORT_QUANTITY_MISS_OR_REDUNDANT_ESTIMATED_QUANTITY_DISPLAY;
  missingOrRedundantCustomerOrderQuantity: PRODUCT_REPORT_QUANTITY_MISS_OR_REDUNDANT_CUSTOMER_QUANTITY_DISPLAY;

  totalCustomerOrderProductReportQuantity: PRODUCT_REPORT_QUANTITY_TOTAL_CUSTOMER_ORDER_QUANTITY_DISPLAY;
  totalEstimatedProductReportQuantity: PRODUCT_REPORT_QUANTITY_TOTAL_ESTIMATED_QUANTITY_DISPLAY;
  totalProductReportQuantity: PRODUCT_REPORT_QUANTITY_TOTAL_QUANTITY_DISPLAY;
  totalOrderToSupplierProductReportQuantity: PRODUCT_REPORT_QUANTITY_TOTAL_ORDER_TO_SUPPLIER_QUANTITY_DISPLAY;
  totalSupplierReceivedProductReportQuantity: PRODUCT_REPORT_QUANTITY_TOTAL_SUPPLIER_RECEIVED_QUANTITY_DISPLAY;
  totalSupplierDeliveredProductReportQuantity: PRODUCT_REPORT_QUANTITY_TOTAL_SUPPLIER_DELIVERED_QUANTITY_DISPLAY;
  totalSupplierProcessedProductReportQuantity: PRODUCT_REPORT_QUANTITY_TOTAL_SUPPLIER_PROCESSED_QUANTITY_DISPLAY;
  // eslint-disable-next-line max-len
  totalMissingOrRedundantCustomerProductReportQuantity: PRODUCT_REPORT_QUANTITY_TOTAL_MISSING_OR_REDUNDANT_CUSTOMER_QUANTITY_DISPLAY;
  // eslint-disable-next-line max-len
  totalMissingOrRedundantSupplierProductReportQuantity: PRODUCT_REPORT_QUANTITY_TOTAL_MISSING_OR_REDUNDANT_SUPPLIER_QUANTITY_DISPLAY;
}

export enum DISPLAY_SETTING_PRODUCT_REPORT_QUANTITY_TEXT {
  customerOrderQuantity = 'Số lượng đặt',
  estimatedQuantity = 'Số lượng báo',
  quantity = 'Số lượng thực',
  orderToSupplierQuantity = 'Số lượng đặt vườn',
  supplierDeliveredQuantity = 'Số lượng vườn giao',
  supplierProcessedQuantity = 'Số lượng sơ chế',
  supplierReceivedQuantity = 'Số lượng nhận',
  missingOrRedundantEstimatedQuantity = 'Báo dư',
  missingOrRedundantCustomerOrderQuantity = 'Thiếu khách',

  totalCustomerOrderProductReportQuantity = 'Tổng khách đặt',
  totalEstimatedProductReportQuantity = 'Tổng dự báo',
  totalProductReportQuantity = 'Tổng thực tế',
  totalOrderToSupplierProductReportQuantity = 'Tổng đặt vườn',
  totalSupplierReceivedProductReportQuantity = 'Tổng thực nhận',
  totalSupplierDeliveredProductReportQuantity = 'Tổng vườn giao',
  totalSupplierProcessedProductReportQuantity = 'Tổng sơ chế',
  // eslint-disable-next-line max-len
  totalMissingOrRedundantCustomerProductReportQuantity = 'Thiếu dư hàng dự báo',
  // eslint-disable-next-line max-len
  totalMissingOrRedundantSupplierProductReportQuantity = 'Thiếu dư hàng khách đặt',
}

export enum DISPLAY_SETTING_PRODUCT_REPORT_QUANTITY_SORT_TEXT {
  customerOrderQuantity = 'SL đặt',
  estimatedQuantity = 'SL báo',
  quantity = 'SL thực',
  orderToSupplierQuantity = 'Đặt vườn',
  supplierDeliveredQuantity = 'Vườn giao',
  supplierProcessedQuantity = 'Sơ chế',
  supplierReceivedQuantity = 'SL nhận',
  missingOrRedundantEstimatedQuantity = 'Báo dư',
  missingOrRedundantCustomerOrderQuantity = 'Thiếu khách',
}

export const INIT_PRODUCT_REPORT_QUANTITY_CUSTOMER_ORDER_QUANTITY_DISPLAY = {
  visible: true,
};
export const INIT_PRODUCT_REPORT_QUANTITY_ESTIMATED_QUANTITY_DISPLAY = {
  visible: true,
};
export const INIT_PRODUCT_REPORT_QUANTITY_QUANTITY_DISPLAY = {
  visible: false,
};
export const INIT_PRODUCT_REPORT_QUANTITY_ORDER_TO_SUPPLIER_QUANTITY_DISPLAY = {
  visible: false,
};
export const INIT_PRODUCT_REPORT_QUANTITY_SUPPLIER_RECEIVED_QUANTITY_DISPLAY = {
  visible: false,
};
export const INIT_PRODUCT_REPORT_QUANTITY_SUPPLIER_DELIVERED_QUANTITY_DISPLAY =
  {
    visible: false,
  };
export const INIT_PRODUCT_REPORT_QUANTITY_SUPPLIER_PROCESSED_QUANTITY_DISPLAY =
  {
    visible: false,
  };
export const INIT_PRODUCT_REPORT_QUANTITY_MISS_OR_REDUNDANT_ESTIMATED_QUANTITY_DISPLAY =
  {
    visible: false,
  };
export const INIT_PRODUCT_REPORT_QUANTITY_MISS_OR_REDUNDANT_CUSTOMER_QUANTITY_DISPLAY =
  {
    visible: false,
  };
export const INIT_PRODUCT_REPORT_QUANTITY_TOTAL_CUSTOMER_ORDER_QUANTITY_DISPLAY =
  {
    visible: true,
  };
export const INIT_PRODUCT_REPORT_QUANTITY_TOTAL_ESTIMATED_QUANTITY_DISPLAY = {
  visible: true,
};
export const INIT_PRODUCT_REPORT_QUANTITY_TOTAL_QUANTITY_DISPLAY = {
  visible: false,
};
export const INIT_PRODUCT_REPORT_QUANTITY_TOTAL_MISSING_OR_REDUNDANT_CUSTOMER_QUANTITY_DISPLAY =
  {
    visible: false,
  };
export const INIT_PRODUCT_REPORT_QUANTITY_TOTAL_MISSING_OR_REDUNDANT_SUPPLIER_QUANTITY_DISPLAY =
  {
    visible: true,
  };
export const INIT_PRODUCT_REPORT_QUANTITY_TOTAL_ORDER_TO_SUPPLIER_QUANTITY_DISPLAY =
  {
    visible: false,
  };
export const INIT_PRODUCT_REPORT_QUANTITY_TOTAL_SUPPLIER_RECEIVED_QUANTITY_DISPLAY =
  {
    visible: false,
  };
export const INIT_PRODUCT_REPORT_QUANTITY_TOTAL_SUPPLIER_DELIVERED_QUANTITY_DISPLAY =
  {
    visible: false,
  };
export const INIT_PRODUCT_REPORT_QUANTITY_TOTAL_SUPPLIER_PROCESSED_QUANTITY_DISPLAY =
  {
    visible: false,
  };

export const INIT_DISPLAY_SETTING_PRODUCT_REPORT_QUANTITY = {
  customerOrderQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_CUSTOMER_ORDER_QUANTITY_DISPLAY,
  estimatedQuantity: INIT_PRODUCT_REPORT_QUANTITY_ESTIMATED_QUANTITY_DISPLAY,
  quantity: INIT_PRODUCT_REPORT_QUANTITY_QUANTITY_DISPLAY,
  orderToSupplierQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_ORDER_TO_SUPPLIER_QUANTITY_DISPLAY,
  supplierReceivedQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_SUPPLIER_RECEIVED_QUANTITY_DISPLAY,
  supplierDeliveredQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_SUPPLIER_DELIVERED_QUANTITY_DISPLAY,
  supplierProcessedQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_SUPPLIER_PROCESSED_QUANTITY_DISPLAY,
  missingOrRedundantEstimatedQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_MISS_OR_REDUNDANT_ESTIMATED_QUANTITY_DISPLAY,
  missingOrRedundantCustomerOrderQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_MISS_OR_REDUNDANT_CUSTOMER_QUANTITY_DISPLAY,

  totalCustomerOrderProductReportQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_TOTAL_CUSTOMER_ORDER_QUANTITY_DISPLAY,
  totalEstimatedProductReportQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_TOTAL_ESTIMATED_QUANTITY_DISPLAY,
  totalProductReportQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_TOTAL_QUANTITY_DISPLAY,
  totalOrderToSupplierProductReportQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_TOTAL_ORDER_TO_SUPPLIER_QUANTITY_DISPLAY,
  totalSupplierReceivedProductReportQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_TOTAL_SUPPLIER_RECEIVED_QUANTITY_DISPLAY,
  totalSupplierDeliveredProductReportQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_TOTAL_SUPPLIER_DELIVERED_QUANTITY_DISPLAY,
  totalSupplierProcessedProductReportQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_TOTAL_SUPPLIER_PROCESSED_QUANTITY_DISPLAY,
  totalMissingOrRedundantCustomerProductReportQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_TOTAL_MISSING_OR_REDUNDANT_CUSTOMER_QUANTITY_DISPLAY,
  totalMissingOrRedundantSupplierProductReportQuantity:
    INIT_PRODUCT_REPORT_QUANTITY_TOTAL_MISSING_OR_REDUNDANT_SUPPLIER_QUANTITY_DISPLAY,
};

// Order Setting Purchase
export interface OrderSettingPurchase {
  orderType: SETTING_ORDER_TYPE;
  orderTime: SETTING_ORDER_TIME;
  quantityDisplay: SETTING_QUANTITY_DISPLAY;
  branchDisplay: SETTING_BRANCH_DISPLAY;
}

export const INIT_ORDER_SETTING_PURCHASE = {
  orderType: INIT_SETTING_ORDER_TYPE,
  orderTime: INIT_SETTING_ORDER_TIME,
  quantityDisplay: INIT_SETTING_QUANTITY_DISPLAY,
  branchDisplay: INIT_SETTING_BRANCH_DISPLAY,
};

// Product Setting Balance

export interface ProductSettingPurchase {
  categoryDisplay: SETTING_CATEGORY_DISPLAY;
  sort: SETTING_SORT;
}

export const INIT_PRODUCT_SETTING_PURCHASE = {
  categoryDisplay: INIT_SETTING_CATEGORY_DISPLAY,
  sort: INIT_SETTING_SORT,
};

export interface ColumnRowFilter {
  filterRow: FILTER_TYPE;
  filterControlRow: FILTER_CONTROL_TYPE;
  filterColumn: FILTER_TYPE;
  filterControlColumn: FILTER_CONTROL_TYPE;
  filterToggleRowValue: FILTER_BALANCE_QUANTITY_TYPE;
  filterToggleColumnValue:
    | FILTER_BALANCE_QUANTITY_TYPE
    | FILTER_PURCHASE_QUANTITY_TYPE
    | any;
  filterToggleStockColumnValue: FILTER_STOCK_TYPE;
  filterToggleStockProcessedColumnValue: FILTER_STOCK_TYPE;
  filterToggleStockCustomerColumnValue: FILTER_STOCK_TYPE;
  filterToggleStockSupplierColumnValue: FILTER_STOCK_TYPE;
  filterToggleOnHandColumnValue: FILTER_STOCK_TYPE;
}

export interface ColumnRowProductReportQuantityFilter {
  filterRow: FILTER_TYPE;
  filterControlRow: FILTER_CONTROL_TYPE;
  filterColumn: FILTER_TYPE;
  filterControlColumn: FILTER_CONTROL_TYPE;
  filterToggleRowValue: FILTER_BALANCE_QUANTITY_TYPE;
  filterToggleColumnValue:
    | FILTER_BALANCE_QUANTITY_TYPE
    | FILTER_PURCHASE_QUANTITY_TYPE
    | any;
  filterToggleStockColumnValue: FILTER_STOCK_TYPE;
  filterToggleStockProcessedColumnValue: FILTER_STOCK_TYPE;
  filterToggleStockCustomerColumnValue: FILTER_STOCK_TYPE;
  filterToggleStockSupplierColumnValue: FILTER_STOCK_TYPE;
  filterQuantityType: FILTER_QUANTITY_TYPE;
}

export const INIT_FILTER_BALANCE_DATA = {
  filterRow: FILTER_TYPE.MULTI,
  filterControlRow: FILTER_CONTROL_TYPE.SWITCH,
  filterColumn: FILTER_TYPE.MULTI,
  filterControlColumn: FILTER_CONTROL_TYPE.SWITCH,
  filterToggleRowValue: FILTER_BALANCE_QUANTITY_TYPE.HAS_QUANTITY,
  filterToggleColumnValue: FILTER_BALANCE_QUANTITY_TYPE.HAS_QUANTITY,
  filterToggleStockColumnValue: FILTER_STOCK_TYPE.ENOUGH,
};

export const INIT_FILTER_PRODUCT_REPORT_QUANTITY_DATA = {
  filterRow: FILTER_TYPE.MULTI,
  filterControlRow: FILTER_CONTROL_TYPE.SWITCH,
  filterColumn: FILTER_TYPE.MULTI,
  filterControlColumn: FILTER_CONTROL_TYPE.SWITCH,
  filterToggleRowValue: FILTER_BALANCE_QUANTITY_TYPE.HAS_QUANTITY,
  filterToggleColumnValue: FILTER_BALANCE_QUANTITY_TYPE.HAS_QUANTITY,
  filterToggleStockColumnValue: FILTER_STOCK_TYPE.ENOUGH,
  filterQuantityType: FILTER_QUANTITY_TYPE.CUSTOMER_ORDER_QUANTITY,
  filterToggleStockProcessedColumnValue: FILTER_STOCK_TYPE.ENOUGH,
  filterToggleStockCustomerColumnValue: FILTER_STOCK_TYPE.ENOUGH,
  filterToggleStockSupplierColumnValue: FILTER_STOCK_TYPE.ENOUGH,
};

export const INIT_FILTER_PURCHASE_DATA = {
  filterRow: FILTER_TYPE.MULTI,
  filterControlRow: FILTER_CONTROL_TYPE.SWITCH,
  filterColumn: FILTER_TYPE.MULTI,
  filterControlColumn: FILTER_CONTROL_TYPE.SWITCH,
  filterToggleRowValue: FILTER_PURCHASE_QUANTITY_TYPE.HAS_QUANTITY,
  filterToggleColumnValue: FILTER_PURCHASE_QUANTITY_TYPE.HAS_QUANTITY,
  filterToggleStockColumnValue: FILTER_STOCK_TYPE.ENOUGH,
};

export const FILTER_ROW_TYPE_TEXT = {
  [FILTER_TYPE.MULTI]: 'Lọc theo nhiều đối tượng',
  [FILTER_TYPE.SINGLE]: 'Lọc theo một đối tượng',
};

export const FILTER_COLUMN_TYPE_TEXT = {
  [FILTER_TYPE.MULTI]: 'Lọc theo nhiều cột',
  [FILTER_TYPE.SINGLE]: 'Lọc theo từng cột',
};

export const FILTER_QUANTITY_TEXT = {
  [FILTER_BALANCE_QUANTITY_TYPE.HAS_QUANTITY]: 'Có số lượng',
  [FILTER_BALANCE_QUANTITY_TYPE.NO_QUANTITY]: 'Không có số lượng',
  [FILTER_PURCHASE_QUANTITY_TYPE.HAS_QUANTITY]: 'Có số lượng',
};

export const FILTER_STOCK_TEXT = {
  [FILTER_STOCK_TYPE.ENOUGH]: 'Đủ hàng',
  [FILTER_STOCK_TYPE.MISSING]: 'Thiếu hàng',
  [FILTER_STOCK_TYPE.REDUNDANT]: 'Thừa hàng',
};

export const FILTER_ON_HAND_TEXT = {
  [FILTER_STOCK_TYPE.ENOUGH]: 'Không tồn',
  [FILTER_STOCK_TYPE.MISSING]: 'Tồn âm',
  [FILTER_STOCK_TYPE.REDUNDANT]: 'Tồn dương',
};

export const FILTER_CONTROL_TYPE_TEXT = {
  [FILTER_CONTROL_TYPE.PANEL]: 'Hiển thị dạng biểu mẫu',
  [FILTER_CONTROL_TYPE.SWITCH]: 'Hiển thị dạng bật/tắt',
  [FILTER_CONTROL_TYPE.PANEL_SWITCH]: 'Hiển thị dạng kết hợp',
};

export enum ENTITY_PRODUCT_INFO {
  ALL = -1, // tât cả
  AVATAR = 0, // hình ảnh
  OPTION_TAG = 1, // nhãn
  CODE = 2, // mã
  ENTITY_CATEGORY = 3, // danh mục
  TOTAL_PRODUCT_OBJECT = 4, // số lượng
  IS_PUBLIC = 5, // công khai
  CREATED_AT = 6, // ngày tạo
  WHOLESALE_PRICE = 7, // giá sỉ
  RETAIL_PRICE = 8, // giá lẻ
  STATUS = 9, // trạng thái
  REUSE_DIARY = 10, // tái sử dụng nhật ký
  ON_HAND = 11, // tồn kho
  AVAILABLE = 12, // có thể bán
}

export const PRODUCT_VIEW_INFO = {
  [ENTITY_PRODUCT_INFO.ALL]: 'Tất cả thông tin',
  [ENTITY_PRODUCT_INFO.AVATAR]: 'Hình ảnh',
  [ENTITY_PRODUCT_INFO.OPTION_TAG]: 'Nhãn',
  [ENTITY_PRODUCT_INFO.CODE]: 'Mã sản phẩm',
  [ENTITY_PRODUCT_INFO.ENTITY_CATEGORY]: 'Danh mục',
  [ENTITY_PRODUCT_INFO.IS_PUBLIC]: 'Nút công khai',
  [ENTITY_PRODUCT_INFO.CREATED_AT]: 'Ngày tạo',
  [ENTITY_PRODUCT_INFO.WHOLESALE_PRICE]: 'Đơn giá sỉ',
  [ENTITY_PRODUCT_INFO.RETAIL_PRICE]: 'Đơn giá lẻ',
  [ENTITY_PRODUCT_INFO.STATUS]: 'Trạng thái',
  [ENTITY_PRODUCT_INFO.TOTAL_PRODUCT_OBJECT]: 'Số lượng đối tượng',
  [ENTITY_PRODUCT_INFO.REUSE_DIARY]: 'Tái sử dụng nhật ký',
  [ENTITY_PRODUCT_INFO.ON_HAND]: 'Tồn kho',
  [ENTITY_PRODUCT_INFO.AVAILABLE]: 'Có thể bán',
};

export enum INVENTORY_ITEM_INFO {
  ALL = -1, // tât cả
  AVATAR = 1, // hình ảnh
  OPTION_TAG = 2, // nhãn
  // CODE = 3, // mã
  IS_PUBLIC = 4, // công khai
  WHOLESALE_PRICE = 5, // giá sỉ
  RETAIL_PRICE = 6, // giá lẻ
  STATUS = 7, // trạng thái
  ON_HAND = 8, // tồn kho
  AVAILABLE = 9, // có thể bán
}

export enum ORDER_INFO {
  ALL = -1, // tât cả
  OPTION_TAG = 2, // tag đơn hàng
  ORDER_TYPE_VALUE = 3, // loại đơn hàng
  TOTAL_QUANTITY = 4, // sl sản phẩm trong đơn hàng
  CUSTOMER_CODE = 5, // mã khách hàng
  CUSTOMER_PHONE = 6, // số điện thoại khách hàng
  CUSTOMER_AVATAR = 7, // avatar khách hàng
  CUSTOMER_GROUP = 8, // nhóm khách hàng
}

export enum CUSTOMER_INFO {
  ALL = -1, // tât cả
  AVATAR = 0, // hình ảnh
  PHONE_NUMBER = 1, // số đt khách hàng
  CHAIN = 2, // chi nhánh
  CUSTOMER_GROUP = 3, // nhóm khách hàng
  EMAIL = 4, // email
}

export enum CUSTOMER_PARTNER_INFO {
  ALL = -1, // tât cả
  AVATAR = 0, // hình ảnh
  PHONE_NUMBER = 1, // số đt khách hàng
  GROUP = 2, // nhóm đối tác
  EMAIL = 3, // email
  ADDRESS = 4, // địa chỉ
  TYPE = 5, // loại đối tác
  CREATED_AT = 6, // ngày tạo
}

export enum BRANCH_PARTNER_INFO {
  ALL = -1, // tât cả
  AVATAR = 0, // hình ảnh
  PHONE_NUMBER = 1, // số đt đối tác
  GROUP = 2, // nhóm đối tác
  EMAIL = 3, // email
  ADDRESS = 4, // địa chỉ
  CREATED_AT = 5, // ngày tạo
}

export enum SUPPLIER_PARTNER_INFO {
  ALL = -1, // tât cả
  AVATAR = 0, // hình ảnh
  PHONE_NUMBER = 1, // số đt đối tác
  GROUP = 2, // nhóm đối tác
  EMAIL = 3, // email
  ADDRESS = 4, // địa chỉ
  TYPE = 5, // loại đối tác
  CREATED_AT = 6, // ngày tạo
}

export enum WAREHOUSE_PARTNER_INFO {
  ALL = -1, // tât cả
  AVATAR = 0, // hình ảnh
  PHONE_NUMBER = 1, // số đt đối tác
  GROUP = 2, // nhóm đối tác
  EMAIL = 3, // email
  ADDRESS = 4, // địa chỉ
  CREATED_AT = 5, // ngày tạo
}

export const ORDER_VIEW_INFO = {
  [ORDER_INFO.ALL]: 'Tất cả thông tin',
  [ORDER_INFO.CUSTOMER_AVATAR]: 'Ảnh đại diện khách hàng',
  [ORDER_INFO.CUSTOMER_CODE]: 'Mã khách hàng',
  [ORDER_INFO.CUSTOMER_GROUP]: 'Nhóm khách hàng',
  [ORDER_INFO.CUSTOMER_PHONE]: 'Số điện thoại',
  [ORDER_INFO.OPTION_TAG]: 'Nhãn đơn hàng',
  [ORDER_INFO.ORDER_TYPE_VALUE]: 'Loại đơn hàng',
  [ORDER_INFO.TOTAL_QUANTITY]: 'Tổng số lượng',
};

export const INVENTORY_ITEM_VIEW_INFO = {
  [INVENTORY_ITEM_INFO.ALL]: 'Tất cả thông tin',
  [INVENTORY_ITEM_INFO.AVATAR]: 'Hình ảnh',
  [INVENTORY_ITEM_INFO.OPTION_TAG]: 'Nhãn',
  // [INVENTORY_ITEM_INFO.CODE]: 'Mã sản phẩm',
  [INVENTORY_ITEM_INFO.IS_PUBLIC]: 'Nút công khai',
  [INVENTORY_ITEM_INFO.WHOLESALE_PRICE]: 'Đơn giá sỉ',
  [INVENTORY_ITEM_INFO.RETAIL_PRICE]: 'Đơn giá lẻ',
  [INVENTORY_ITEM_INFO.STATUS]: 'Trạng thái',
  [INVENTORY_ITEM_INFO.ON_HAND]: 'Tồn kho',
  [INVENTORY_ITEM_INFO.AVAILABLE]: 'Có thể bán',
};

export const CUSTOMER_VIEW_INFO = {
  [CUSTOMER_INFO.ALL]: 'Tất cả thông tin',
  [CUSTOMER_INFO.AVATAR]: 'Hình ảnh đại diện',
  [CUSTOMER_INFO.PHONE_NUMBER]: 'Số điện thoại',
  [CUSTOMER_INFO.CHAIN]: 'Chi nhánh',
  [CUSTOMER_INFO.CUSTOMER_GROUP]: 'Nhóm khách hàng',
  [CUSTOMER_INFO.EMAIL]: 'Email',
};

export const CUSTOMER_PARTNER_VIEW_INFO = {
  [CUSTOMER_PARTNER_INFO.ALL]: 'Tất cả thông tin',
  [CUSTOMER_PARTNER_INFO.AVATAR]: 'Hình ảnh đại diện',
  [CUSTOMER_PARTNER_INFO.PHONE_NUMBER]: 'Số điện thoại',
  [CUSTOMER_PARTNER_INFO.ADDRESS]: 'Địa chỉ đối tác',
  [CUSTOMER_PARTNER_INFO.EMAIL]: 'Email',
  [CUSTOMER_PARTNER_INFO.TYPE]: 'Loại đối tác',
  [CUSTOMER_PARTNER_INFO.GROUP]: 'Nhóm đối tác',
  [CUSTOMER_PARTNER_INFO.CREATED_AT]: 'Ngày tạo',
};

export const BRANCH_PARTNER_VIEW_INFO = {
  [BRANCH_PARTNER_INFO.ALL]: 'Tất cả thông tin',
  [BRANCH_PARTNER_INFO.AVATAR]: 'Hình ảnh đại diện',
  [BRANCH_PARTNER_INFO.PHONE_NUMBER]: 'Số điện thoại',
  [BRANCH_PARTNER_INFO.ADDRESS]: 'Địa chỉ đối tác',
  [BRANCH_PARTNER_INFO.EMAIL]: 'Email',
  [BRANCH_PARTNER_INFO.GROUP]: 'Nhóm đối tác',
  [BRANCH_PARTNER_INFO.CREATED_AT]: 'Ngày tạo',
};

export const SUPPLIER_PARTNER_VIEW_INFO = {
  [SUPPLIER_PARTNER_INFO.ALL]: 'Tất cả thông tin',
  [SUPPLIER_PARTNER_INFO.AVATAR]: 'Hình ảnh đại diện',
  [SUPPLIER_PARTNER_INFO.PHONE_NUMBER]: 'Số điện thoại',
  [SUPPLIER_PARTNER_INFO.ADDRESS]: 'Địa chỉ NCC',
  [SUPPLIER_PARTNER_INFO.EMAIL]: 'Email',
  [SUPPLIER_PARTNER_INFO.GROUP]: 'Nhóm NCC',
  [SUPPLIER_PARTNER_INFO.TYPE]: 'Loại NCC',
  [SUPPLIER_PARTNER_INFO.CREATED_AT]: 'Ngày tạo',
};

export const WAREHOUSE_PARTNER_VIEW_INFO = {
  [WAREHOUSE_PARTNER_INFO.ALL]: 'Tất cả thông tin',
  [WAREHOUSE_PARTNER_INFO.AVATAR]: 'Hình ảnh đại',
  [WAREHOUSE_PARTNER_INFO.PHONE_NUMBER]: 'Số điện thoại',
  [WAREHOUSE_PARTNER_INFO.ADDRESS]: 'Địa chỉ CNSX',
  [WAREHOUSE_PARTNER_INFO.EMAIL]: 'Email',
  [WAREHOUSE_PARTNER_INFO.GROUP]: 'Nhóm CNSX',
  [WAREHOUSE_PARTNER_INFO.CREATED_AT]: 'Ngày tạo',
};

export enum SETTING_VIEW_TABLE_TYPE {
  PRODUCT = 'PRODUCT',
  INVENTORY_ITEM = 'INVENTORY_ITEM',
  ORDER = 'ORDER',
  CUSTOMER = 'CUSTOMER',
  CUSTOMER_PARTNER = 'CUSTOMER_PARTNER',
  BRANCH_PARTNER = 'BRANCH_PARTNER',
  SUPPLIER_PARTNER = 'SUPPLIER_PARTNER',
  WAREHOUSE_PARTNER = 'WAREHOUSE_PARTNER',
}

export const INIT_VIEW_INFO_DATA = {
  [SETTING_VIEW_TABLE_TYPE.PRODUCT]: [
    ENTITY_PRODUCT_INFO.AVATAR,
    ENTITY_PRODUCT_INFO.OPTION_TAG,
    // ENTITY_PRODUCT_INFO.CODE,
    ENTITY_PRODUCT_INFO.ENTITY_CATEGORY,
    ENTITY_PRODUCT_INFO.RETAIL_PRICE,
    ENTITY_PRODUCT_INFO.IS_PUBLIC,
    ENTITY_PRODUCT_INFO.CREATED_AT,
    ENTITY_PRODUCT_INFO.TOTAL_PRODUCT_OBJECT,
    ENTITY_PRODUCT_INFO.STATUS,
    ENTITY_PRODUCT_INFO.REUSE_DIARY,
    ENTITY_PRODUCT_INFO.ON_HAND,
    ENTITY_PRODUCT_INFO.AVAILABLE,
  ],
  [SETTING_VIEW_TABLE_TYPE.INVENTORY_ITEM]: [
    INVENTORY_ITEM_INFO.AVATAR,
    INVENTORY_ITEM_INFO.OPTION_TAG,
    // INVENTORY_ITEM_INFO.CODE,
    INVENTORY_ITEM_INFO.IS_PUBLIC,
    INVENTORY_ITEM_INFO.RETAIL_PRICE,
    INVENTORY_ITEM_INFO.WHOLESALE_PRICE,
    INVENTORY_ITEM_INFO.STATUS,
    INVENTORY_ITEM_INFO.ON_HAND,
    INVENTORY_ITEM_INFO.AVAILABLE,
  ],
  [SETTING_VIEW_TABLE_TYPE.ORDER]: [
    ORDER_INFO.CUSTOMER_AVATAR,
    ORDER_INFO.CUSTOMER_CODE,
    ORDER_INFO.CUSTOMER_PHONE,
    ORDER_INFO.OPTION_TAG,
    ORDER_INFO.ORDER_TYPE_VALUE,
    ORDER_INFO.TOTAL_QUANTITY,
  ],
  [SETTING_VIEW_TABLE_TYPE.CUSTOMER]: [
    CUSTOMER_INFO.AVATAR,
    CUSTOMER_INFO.PHONE_NUMBER,
    CUSTOMER_INFO.CHAIN,
    CUSTOMER_INFO.CUSTOMER_GROUP,
    CUSTOMER_INFO.EMAIL,
  ],
  [SETTING_VIEW_TABLE_TYPE.CUSTOMER_PARTNER]: [
    CUSTOMER_PARTNER_INFO.AVATAR,
    CUSTOMER_PARTNER_INFO.PHONE_NUMBER,
    CUSTOMER_PARTNER_INFO.ADDRESS,
    CUSTOMER_PARTNER_INFO.GROUP,
    CUSTOMER_PARTNER_INFO.EMAIL,
    CUSTOMER_PARTNER_INFO.TYPE,
    CUSTOMER_PARTNER_INFO.CREATED_AT,
  ],
  [SETTING_VIEW_TABLE_TYPE.BRANCH_PARTNER]: [
    BRANCH_PARTNER_INFO.AVATAR,
    BRANCH_PARTNER_INFO.PHONE_NUMBER,
    BRANCH_PARTNER_INFO.ADDRESS,
    BRANCH_PARTNER_INFO.GROUP,
    BRANCH_PARTNER_INFO.EMAIL,
    BRANCH_PARTNER_INFO.CREATED_AT,
  ],
  [SETTING_VIEW_TABLE_TYPE.SUPPLIER_PARTNER]: [
    SUPPLIER_PARTNER_INFO.AVATAR,
    SUPPLIER_PARTNER_INFO.PHONE_NUMBER,
    SUPPLIER_PARTNER_INFO.ADDRESS,
    SUPPLIER_PARTNER_INFO.GROUP,
    SUPPLIER_PARTNER_INFO.EMAIL,
    SUPPLIER_PARTNER_INFO.TYPE,
    SUPPLIER_PARTNER_INFO.CREATED_AT,
  ],
  [SETTING_VIEW_TABLE_TYPE.WAREHOUSE_PARTNER]: [
    WAREHOUSE_PARTNER_INFO.AVATAR,
    WAREHOUSE_PARTNER_INFO.PHONE_NUMBER,
    WAREHOUSE_PARTNER_INFO.ADDRESS,
    WAREHOUSE_PARTNER_INFO.GROUP,
    WAREHOUSE_PARTNER_INFO.EMAIL,
    WAREHOUSE_PARTNER_INFO.CREATED_AT,
  ],
};

export const getSettingViewInfoTable = (
  tableName: SETTING_VIEW_TABLE_TYPE,
  entityID
) => `${tableName}_${entityID}_view_info_table_setting`;

export const shouldToHideColumnWithViewInfoSetting = (
  currentSetting: any[] | any,
  value: any,
  tableName: SETTING_VIEW_TABLE_TYPE
) => {
  if (currentSetting == undefined) {
    const defaultViewInfoSetting: any[] = INIT_VIEW_INFO_DATA[tableName];
    if (defaultViewInfoSetting.includes(value)) {
      return false;
    }
  }

  if (currentSetting?.includes(-1)) {
    return false;
  }

  if (currentSetting?.includes(value)) {
    return false;
  }

  return true;
};

// 0: khong co, 1: co it, 2: co vua, 3: co nhieu
export enum PRODUCT_RELATIVE_QUANTITY {
  NONE = 0, // hết hàng
  FEW = 1, // có ít
  MEDIUM = 2, // có vừa
  MANY = 3, // có nhiều
  HAS_QUANTITY = 4, // có hàng
  ALL = -1, // không lọc
}

export const UNLIMITED_CO_BUY_PROMOTION_QUANTITY = -1;
export const UNLIMITED_CO_BUY_PER_CUSTOMER_LIMIT_QUANTITY = -1;

// catalog
export const CATALOG_DISPLAY_TYPE = {
  AUTO: 0,
  MANUAL: 1,
  CATEGORY: 2,
};

export const STAMP_TARGET_TYPE = {
  PRODUCT_OBJECT: 0,
  PRODUCT: 1,
  AREA: 2,
  ENTITY_PRODUCT: 3,
  ENTITY_PRODUCT_OBJECT: 4,
  ENTITY_AREA: 5,
};

export const STAMP_DISPLAY_TYPE = {
  VERTICAL_RECTANGLE: 0,
  ELLIPSE: 1,
  HORIZONTAL_RECTANGLE: 2,
  INFO_RECTANGLE: 3,
  SHIELD: 4,
};

export const CATALOG_DISPLAY_TYPE_NAME = {
  AUTO: 'Tự động',
  CATEGORY: 'Danh mục',
  MANUAL: 'Thủ công',
};

export const CATALOG_SORT_TYPE = {
  HIGHLIGHT: 0,
  BEST_SELLING: 1,
  LATEST: 2,
  HIGHLY_RECOMMENDED: 3,
  LOWEST_PRICE: 4,
};

export const CATALOG_SORT_TYPE_NAME = {
  HIGHLIGHT: 'Nổi bật nhất',
  BEST_SELLING: 'Bán chạy nhất',
  LATEST: 'Mới nhất',
  HIGHLY_RECOMMENDED: 'Đánh giá cao nhất',
  LOWEST_PRICE: 'Giá thấp nhất',
};

export const FRAME_TYPE = {
  AREA: 'AREA',
  BANNER: 'BANNER',
  CAMPAIGN: 'CAMPAIGN',
  CATALOG: 'CATALOG',
  CATEGORY: 'CATEGORY',
  CERTIFICATE: 'CERTIFICATE',
  CO_BUY: 'CO_BUY',
  FLASH_SALE: 'FLASH_SALE',
  GALLERY: 'GALLERY',
  ORIGIN_TRACING: 'ORIGIN_TRACING',
  PRODUCT: 'PRODUCT',
  STORY: 'STORY',
  SUGGESTED_PRODUCT: 'SUGGESTED_PRODUCT',
  COMBO: 'COMBO',
  COUPON: 'COUPON',
  WHOLESALE_DIGITAL_MENU: 'WHOLESALE_DIGITAL_MENU',
};

export const ACTIVE_STATUS = {
  ACTIVATED: 0,
  DEACTIVATED: 1,
  PAUSED: 2,
  DRAFTED: 3,
  TEMP_REMOVED: 4,
};

export const DIARY_PROPERTIES = {
  TEXT: 0,
  NUMBER: 1,
  LINK: 2,
};

export const PARTNER_NOTE_TYPE = {
  DELIVERY: 0, // Vận chuyển
  SHIPPING: 1, // Giao hàng (dùng cho danh sách địa chỉ giao hàng)
  OTHER: 2,
};

export const PARTNER_NOTE_TYPE_TEXT = {
  [PARTNER_NOTE_TYPE.DELIVERY]: {
    full: 'Thông tin vận chuyển',
    short: 'Vận chuyển',
    color: 'red',
  },
  [PARTNER_NOTE_TYPE.SHIPPING]: {
    full: 'Thông tin giao hàng',
    short: 'Giao hàng',
    color: 'link',
  },
  [PARTNER_NOTE_TYPE.OTHER]: {
    full: 'Thông tin khác',
    short: 'Khác',
    color: 'secondary',
  },
};

export const ICONS = {
  HOME: {
    paths: [
      'm498.195312 222.695312c-.011718-.011718-.023437-.023437-.035156-.035156l-208.855468-208.847656c-8.902344-8.90625-20.738282-13.8125-33.328126-13.8125-12.589843 0-24.425781 4.902344-33.332031 13.808594l-208.746093 208.742187c-.070313.070313-.140626.144531-.210938.214844-18.28125 18.386719-18.25 48.21875.089844 66.558594 8.378906 8.382812 19.445312 13.238281 31.277344 13.746093.480468.046876.964843.070313 1.453124.070313h8.324219v153.699219c0 30.414062 24.746094 55.160156 55.167969 55.160156h81.710938c8.28125 0 15-6.714844 15-15v-120.5c0-13.878906 11.289062-25.167969 25.167968-25.167969h48.195313c13.878906 0 25.167969 11.289063 25.167969 25.167969v120.5c0 8.285156 6.714843 15 15 15h81.710937c30.421875 0 55.167969-24.746094 55.167969-55.160156v-153.699219h7.71875c12.585937 0 24.421875-4.902344 33.332031-13.808594 18.359375-18.371093 18.367187-48.253906.023437-66.636719zm0 0',
    ],
    viewBox: '0 0 512 512',
  },
  CLOSE: {
    paths: [
      'm194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0',
    ],
    viewBox: '0 0 329.26933 329',
  },
  BOX: {
    paths: [
      'm16.12 1.929-10.891 5.576-4.329-2.13 10.699-5.283c.24-.122.528-.122.78 0z',
      'm23.088 5.375-11.082 5.49-4.15-2.045-.6-.305 10.903-5.575.6.304z',
      'm11.118 12.447-.012 11.553-10.614-5.539c-.3-.158-.492-.475-.492-.816v-10.688l4.498 2.216v3.896c0 .499.408.913.9.913s.9-.414.9-.913v-2.995l.6.292z',
      'm23.988 6.969-11.07 5.466-.012 11.553 11.094-5.793z',
    ],
    viewBox: '0 0 24 24',
  },
  CHECK: {
    paths: [
      'M204.288,0C91.648,0,0,91.648,0,204.288s91.648,204.288,204.288,204.288s204.288-91.648,204.288-204.288 S316.928,0,204.288,0z M318.464,150.528l-130.56,129.536c-7.68,7.68-19.968,8.192-28.16,0.512L90.624,217.6 c-8.192-7.68-8.704-20.48-1.536-28.672c7.68-8.192,20.48-8.704,28.672-1.024l54.784,50.176L289.28,121.344 c8.192-8.192,20.992-8.192,29.184,0C326.656,129.536,326.656,142.336,318.464,150.528z',
    ],
    viewBox: '0 0 408.576 408.576',
  },
  FACEBOOK: {
    paths: [
      'M48.875,0C21.882,0,0,21.882,0,48.875S21.882,97.75,48.875,97.75S97.75,75.868,97.75,48.875S75.868,0,48.875,0z M67.521,24.89l-6.76,0.003c-5.301,0-6.326,2.519-6.326,6.215v8.15h12.641L67.07,52.023H54.436v32.758H41.251V52.023H30.229V39.258 h11.022v-9.414c0-10.925,6.675-16.875,16.42-16.875l9.851,0.015V24.89L67.521,24.89z',
    ],
    viewBox: '0 0 97.75 97.75',
  },
  LOCATION2: {
    paths: [
      'M19.1773 2.9731C17.2601 1.05586 14.711 0 11.9997 0C9.28833 0 6.73917 1.05586 4.82198 2.9731C2.90474 4.89038 1.84888 7.43945 1.84888 10.1508C1.84888 15.6357 7.03504 20.1978 9.82125 22.6487C10.2084 22.9893 10.5428 23.2835 10.8092 23.5323C11.1429 23.844 11.5713 23.9999 11.9996 23.9999C12.428 23.9999 12.8563 23.844 13.1901 23.5323C13.4565 23.2834 13.7909 22.9893 14.1781 22.6487C16.9643 20.1978 22.1504 15.6357 22.1504 10.1508C22.1504 7.43945 21.0946 4.89038 19.1773 2.9731ZM13.2495 21.5932C12.8538 21.9412 12.5121 22.2419 12.2304 22.505C12.101 22.6258 11.8983 22.6258 11.7688 22.505C11.4871 22.2418 11.1454 21.9412 10.7498 21.5931C8.13037 19.289 3.25466 15 3.25466 10.1508C3.25466 5.32885 7.17759 1.40592 11.9996 1.40592C16.8215 1.40592 20.7445 5.32885 20.7445 10.1508C20.7445 15 15.8688 19.289 13.2495 21.5932Z',
      'M12.0004 5.29395C9.53382 5.29395 7.5271 7.30063 7.5271 9.76725C7.5271 12.2339 9.53382 14.2405 12.0004 14.2405C14.4671 14.2405 16.4737 12.2339 16.4737 9.76725C16.4737 7.30063 14.4671 5.29395 12.0004 5.29395ZM12.0004 12.8346C10.309 12.8346 8.93298 11.4585 8.93298 9.7672C8.93298 8.07585 10.309 6.69978 12.0004 6.69978C13.6918 6.69978 15.0678 8.07585 15.0678 9.7672C15.0678 11.4585 13.6918 12.8346 12.0004 12.8346Z',
    ],
    viewBox: '0 0 24 24',
  },
  MESSAGE: {
    paths: [
      'm256 0c-141.484375 0-256 114.496094-256 256 0 44.902344 11.710938 88.757812 33.949219 127.4375l-32.984375 102.429688c-2.300782 7.140624-.410156 14.96875 4.894531 20.273437 5.253906 5.253906 13.0625 7.214844 20.273437 4.894531l102.429688-32.984375c38.679688 22.238281 82.535156 33.949219 127.4375 33.949219 141.484375 0 256-114.496094 256-256 0-141.484375-114.496094-256-256-256zm0 472c-40.558594 0-80.09375-11.316406-114.332031-32.726562-4.925781-3.078126-11.042969-3.910157-16.734375-2.078126l-73.941406 23.8125 23.8125-73.941406c1.804687-5.609375 1.042968-11.734375-2.082032-16.734375-21.40625-34.238281-32.722656-73.773437-32.722656-114.332031 0-119.101562 96.898438-216 216-216s216 96.898438 216 216-96.898438 216-216 216zm25-216c0 13.804688-11.191406 25-25 25s-25-11.195312-25-25c0-13.808594 11.191406-25 25-25s25 11.191406 25 25zm100 0c0 13.804688-11.191406 25-25 25s-25-11.195312-25-25c0-13.808594 11.191406-25 25-25s25 11.191406 25 25zm-200 0c0 13.804688-11.191406 25-25 25-13.804688 0-25-11.195312-25-25 0-13.808594 11.195312-25 25-25 13.808594 0 25 11.191406 25 25zm0 0',
    ],
    viewBox: '0 0 512 512.0002',
  },
  PLUS: {
    paths: [
      'm437.332031 192h-160v-160c0-17.664062-14.335937-32-32-32h-21.332031c-17.664062 0-32 14.335938-32 32v160h-160c-17.664062 0-32 14.335938-32 32v21.332031c0 17.664063 14.335938 32 32 32h160v160c0 17.664063 14.335938 32 32 32h21.332031c17.664063 0 32-14.335937 32-32v-160h160c17.664063 0 32-14.335937 32-32v-21.332031c0-17.664062-14.335937-32-32-32zm0 0',
    ],
    viewBox: '0 0 469.33333 469.33333',
  },
  PHONE: {
    paths: [
      'M20.557 5.59453L18.0609 3.10078C17.7562 2.79609 17.3484 2.625 16.9172 2.625C16.4859 2.625 16.0781 2.79375 15.7734 3.10078L13.0852 5.78437C12.7805 6.08906 12.6094 6.49922 12.6094 6.93047C12.6094 7.36406 12.7781 7.76953 13.0852 8.07656L15.1852 10.1789C14.7068 11.2936 14.0194 12.3063 13.1602 13.1625C12.3 14.0273 11.2945 14.7094 10.1789 15.1922L8.07891 13.0898C7.77422 12.7852 7.36641 12.6141 6.93516 12.6141C6.72244 12.6133 6.51172 12.655 6.31532 12.7366C6.11892 12.8183 5.9408 12.9384 5.79141 13.0898L3.10078 15.7734C2.79609 16.0781 2.625 16.4883 2.625 16.9195C2.625 17.3531 2.79375 17.7586 3.10078 18.0656L5.59453 20.5594C6.11484 21.0797 6.83203 21.3773 7.56797 21.3773C7.72031 21.3773 7.86797 21.3656 8.01797 21.3398C11.1211 20.8289 14.2008 19.1766 16.6875 16.6922C19.1719 14.2031 20.8219 11.1234 21.3375 8.01797C21.4852 7.13672 21.1898 6.22969 20.557 5.59453ZM19.6758 7.73906C19.2188 10.5023 17.7328 13.2586 15.4945 15.4969C13.2562 17.7352 10.5023 19.2211 7.73906 19.6781C7.39219 19.7367 7.03594 19.6195 6.78281 19.3687L4.33359 16.9195L6.93047 14.3203L9.73828 17.1328L9.75937 17.1539L10.2656 16.9664C11.8006 16.402 13.1945 15.5107 14.3508 14.354C15.507 13.1974 16.3979 11.8032 16.9617 10.268L17.1492 9.76172L14.318 6.93281L16.9148 4.33359L19.3641 6.78281C19.6172 7.03594 19.7344 7.39219 19.6758 7.73906Z',
    ],
    viewBox: '0 0 24 24',
  },
  TICK: {
    paths: [
      'M12 0C5.38346 0 0 5.38346 0 12C0 18.6165 5.38346 24 12 24C18.6165 24 24 18.6165 24 12C24 5.38346 18.6165 0 12 0ZM18.7068 8.84211L11.0376 16.4511C10.5865 16.9023 9.86466 16.9323 9.38346 16.4812L5.32331 12.782C4.84211 12.3308 4.81203 11.5789 5.23308 11.0977C5.68421 10.6165 6.43609 10.5865 6.91729 11.0376L10.1353 13.985L16.9925 7.12782C17.4737 6.64662 18.2256 6.64662 18.7068 7.12782C19.188 7.60902 19.188 8.3609 18.7068 8.84211Z',
    ],
    viewBox: '0 0 24 24',
  },
  SHIPPING: {
    paths: [
      'M9.00002 5.02539C7.73147 5.02539 6.69946 6.05744 6.69946 7.32595C6.69946 8.59445 7.73147 9.6265 9.00002 9.6265C10.2686 9.6265 11.3006 8.59445 11.3006 7.32595C11.3006 6.05744 10.2685 5.02539 9.00002 5.02539Z',
      'M14.3833 2.22982C12.9454 0.791894 11.0336 0 9.00006 0C6.96655 0 5.05471 0.791894 3.61682 2.22982C2.17886 3.66778 1.38696 5.57958 1.38696 7.61305C1.38696 11.7268 5.27665 15.1484 7.36634 16.9866C7.6567 17.242 7.90747 17.4626 8.10719 17.6492C8.35754 17.8831 8.67873 18 9.00002 18C9.32128 18 9.64254 17.883 9.89285 17.6492C10.0926 17.4626 10.3434 17.2421 10.6337 16.9866C12.7234 15.1484 16.6131 11.7268 16.6131 7.61309C16.6131 5.57958 15.8212 3.66778 14.3833 2.22982ZM9.00006 10.6804C7.1501 10.6804 5.64509 9.17536 5.64509 7.3254C5.64509 5.47545 7.1501 3.97044 9.00006 3.97044C10.85 3.97044 12.355 5.47545 12.355 7.3254C12.355 9.17536 10.85 10.6804 9.00006 10.6804Z',
    ],
    viewBox: '0 0 18 18',
  },
  FAST_DELIVERY: {
    paths: [
      'M34.2188 10.0327C38.3804 10.9984 39.9723 13.4319 41.9681 16.7812H34.2188V10.0327ZM9.89795 17.0625C10.7128 17.0625 11.3042 17.4558 11.3042 18.375C11.3042 19.1503 10.6769 19.7791 9.90198 19.7812H1.40625C0.629517 19.7812 0 20.4111 0 21.1875C0 21.9642 0.629517 22.5938 1.40625 22.5938H14.0625C14.8466 22.5938 15.4742 23.2229 15.4742 24C15.4742 24.7767 14.8447 25.4062 14.068 25.4062H1.40625C0.629517 25.4062 0 26.0358 0 26.8125C0 27.5892 0.629517 28.2188 1.40625 28.2188H4.5V32.4375C4.5 33.2142 5.12952 33.8438 5.90625 33.8438H8.73303C9.23694 36.3259 11.4302 38.1562 14.0156 38.1562C16.6011 38.1562 18.7943 36.3259 19.2982 33.8438H33.5768C34.0807 36.3259 36.2739 38.1562 38.8594 38.1562C41.4448 38.1562 43.6381 36.3259 44.142 33.8438H46.5938C47.3705 33.8438 48 33.2142 48 32.4375V24C48 19.8739 43.6479 19.6 43.6439 19.5938H32.8125C32.0358 19.5938 31.4062 18.9642 31.4062 18.1875V9.75H5.90625C5.12952 9.75 4.5 10.3795 4.5 11.1562V14.25H2.8125C2.03577 14.25 1.40625 14.8795 1.40625 15.6562C1.40625 16.433 2.03577 17.0625 2.8125 17.0625H9.89795ZM40.6824 30.9426C41.6891 31.9493 41.6891 33.5823 40.6824 34.589C39.063 36.2084 36.2812 35.0563 36.2812 32.7656C36.2812 30.4753 39.063 29.3232 40.6824 30.9426ZM15.8386 30.9426C16.8453 31.9493 16.8453 33.5823 15.8386 34.589C14.2192 36.2084 11.4375 35.0563 11.4375 32.7656C11.4375 30.4753 14.2192 29.3232 15.8386 30.9426Z',
    ],
    viewBox: '0 0 48 48',
  },
  MAIL: {
    paths: [
      'M15.3213 0.8125H0.696289C0.385156 0.8125 0.133789 1.06387 0.133789 1.375V12.625C0.133789 12.9361 0.385156 13.1875 0.696289 13.1875H15.3213C15.6324 13.1875 15.8838 12.9361 15.8838 12.625V1.375C15.8838 1.06387 15.6324 0.8125 15.3213 0.8125ZM14.6182 2.76016V11.9219H1.39941V2.76016L0.914258 2.38223L1.60508 1.49453L2.35742 2.07988H13.6619L14.4143 1.49453L15.1051 2.38223L14.6182 2.76016ZM13.6619 2.07812L8.00879 6.47266L2.35566 2.07812L1.60332 1.49277L0.9125 2.38047L1.39766 2.7584L7.40234 7.42715C7.57503 7.56131 7.78748 7.63413 8.00615 7.63413C8.22483 7.63413 8.43727 7.56131 8.60996 7.42715L14.6182 2.76016L15.1033 2.38223L14.4125 1.49453L13.6619 2.07812Z',
    ],
    viewBox: '0 0 16 14',
  },
  COPY: {
    paths: [
      `M502.714,0c-2.71,0-262.286,0-262.286,0C194.178,0,153,42.425,153,87.429l-25.267,0.59
    c-46.228,0-84.019,41.834-84.019,86.838V612c0,45.004,41.179,87.428,87.429,87.428H459c46.249,0,87.428-42.424,87.428-87.428
    h21.857c46.25,0,87.429-42.424,87.429-87.428v-349.19L502.714,0z M459,655.715H131.143c-22.95,0-43.714-21.441-43.714-43.715
    V174.857c0-22.272,18.688-42.993,41.638-42.993L153,131.143v393.429C153,569.576,194.178,612,240.428,612h262.286
    C502.714,634.273,481.949,655.715,459,655.715z M612,524.572c0,22.271-20.765,43.713-43.715,43.713H240.428
    c-22.95,0-43.714-21.441-43.714-43.713V87.429c0-22.272,20.764-43.714,43.714-43.714H459c-0.351,50.337,0,87.975,0,87.975
    c0,45.419,40.872,86.882,87.428,86.882c0,0,23.213,0,65.572,0V524.572z M546.428,174.857c-23.277,0-43.714-42.293-43.714-64.981
    c0,0,0-22.994,0-65.484v-0.044L612,174.857H546.428z M502.714,306.394H306c-12.065,0-21.857,9.77-21.857,21.835
    c0,12.065,9.792,21.835,21.857,21.835h196.714c12.065,0,21.857-9.771,21.857-21.835
    C524.571,316.164,514.779,306.394,502.714,306.394z M502.714,415.57H306c-12.065,0-21.857,9.77-21.857,21.834
    c0,12.066,9.792,21.836,21.857,21.836h196.714c12.065,0,21.857-9.77,21.857-21.836C524.571,425.34,514.779,415.57,502.714,415.57
    z`,
    ],
    viewBox: '0 0 699.428 699.428',
  },
};

export const ORDER_STATUS = {
  ERROR: -2,
  ALL: -1,
  /**
   * Soạn hàng = 0 (Chờ xử lý)
   * */
  PENDING: 0,
  /**
   * Đóng gói = 1 (Xử lý)
   */
  PROCESSING: 1,
  /**
   * Đang giao hàng = 2
   */
  DELIVERY: 2,
  /**
   * Chờ khách hàng xác nhận = 3
   */
  CUSTOMER_CONFIRM: 3,
  /**
   * Đã hủy = 4
   */
  REJECT: 4,
  /**
   * Bản nháp khách hàng = 5
   */
  CUSTOMER_DRAFT: 5,
  /**
   * Hoàn thành đơn = 6
   */
  COMPLETE: 6,
  /**
   * Tiền xử lý = 7
   */
  PRE_PROCESSING: 7,
  /**
   * Chờ nhà cung cấp xác nhận = 8
   */
  SUPPLIER_CONFIRM: 8,
  /**
   * Nhận đơn = 9 (Chờ thực thi)
   */
  PENDING_EXECUTE: 9,
  /**
   * Bản nháp nhà cung cấp = 10
   */
  SUPPLIER_DRAFT: 10,
  ADDITIONAL_ORDER: 11,
  /**
   * Đơn đã gộp = 12
   */
  MERGED: 12,
};

export const DEFAULT_FILTER_BUY_ORDER_STATUS = [
  ORDER_STATUS.PENDING_EXECUTE,
  ORDER_STATUS.PENDING,
  ORDER_STATUS.PROCESSING,
  ORDER_STATUS.DELIVERY,
  ORDER_STATUS.CUSTOMER_CONFIRM,
];

export const CHAIN_ORDER_STATUS_ALLOW_REJECT = [
  ORDER_STATUS.PRE_PROCESSING,
  ORDER_STATUS.CUSTOMER_CONFIRM,
  ORDER_STATUS.PENDING_EXECUTE,
  ORDER_STATUS.PENDING,
  ORDER_STATUS.PROCESSING,
  ORDER_STATUS.DELIVERY,
  ORDER_STATUS.SUPPLIER_CONFIRM,
  ORDER_STATUS.SUPPLIER_DRAFT,
];

export const CHAIN_ORDER_STATUS_ALLOW_DRAFT = [
  ORDER_STATUS.PENDING,
  ORDER_STATUS.PROCESSING,
];

export const ORDER_STATUS_ALLOW_REJECT = [
  ORDER_STATUS.PRE_PROCESSING,
  ORDER_STATUS.CUSTOMER_CONFIRM,
  ORDER_STATUS.PENDING_EXECUTE,
  ORDER_STATUS.PENDING,
  ORDER_STATUS.PROCESSING,
  ORDER_STATUS.DELIVERY,
  ORDER_STATUS.SUPPLIER_CONFIRM,
  ORDER_STATUS.SUPPLIER_DRAFT,
];

export const ORDER_STATUS_ALLOW_DRAFT = [
  ORDER_STATUS.PENDING,
  ORDER_STATUS.PROCESSING,
];

export const ORDER_STATUS_TEXT = {
  [ORDER_STATUS.ERROR]: 'Lỗi chưa liên kết SP',
  [ORDER_STATUS.ALL]: 'Tất cả trạng thái',
  [ORDER_STATUS.PENDING]: 'Soạn hàng',
  [ORDER_STATUS.PROCESSING]: 'Đóng gói',
  [ORDER_STATUS.DELIVERY]: 'Giao hàng',
  [ORDER_STATUS.CUSTOMER_CONFIRM]: 'Kiểm hàng',
  [ORDER_STATUS.REJECT]: 'Đã hủy',
  [ORDER_STATUS.CUSTOMER_DRAFT]: 'Bản nháp KH',
  [ORDER_STATUS.COMPLETE]: 'Hoàn thành',
  [ORDER_STATUS.PRE_PROCESSING]: 'Tiền xử lý',
  [ORDER_STATUS.SUPPLIER_CONFIRM]: 'Kiểm hàng',
  [ORDER_STATUS.PENDING_EXECUTE]: 'Nhận đơn',
  [ORDER_STATUS.SUPPLIER_DRAFT]: 'Bản nháp NCC',
  [ORDER_STATUS.ADDITIONAL_ORDER]: 'Đơn bổ sung',
  [ORDER_STATUS.MERGED]: 'Đơn đã gộp',
};

export const ACTION_ORDER_STATUS_TEXT = {
  [ORDER_STATUS.ERROR]: 'Lỗi chưa liên kết SP',
  [ORDER_STATUS.ALL]: 'Tất cả trạng thái',
  [ORDER_STATUS.PENDING]: 'Soạn hàng',
  [ORDER_STATUS.PROCESSING]: 'Đóng gói',
  [ORDER_STATUS.DELIVERY]: 'Giao hàng',
  [ORDER_STATUS.CUSTOMER_CONFIRM]: 'Kiểm hàng',
  [ORDER_STATUS.REJECT]: 'Hủy đơn hàng',
  [ORDER_STATUS.CUSTOMER_DRAFT]: 'Bản nháp KH',
  [ORDER_STATUS.COMPLETE]: 'Hoàn thành',
  [ORDER_STATUS.PRE_PROCESSING]: 'Tiền xử lý',
  [ORDER_STATUS.SUPPLIER_CONFIRM]: 'Kiểm hàng',
  [ORDER_STATUS.PENDING_EXECUTE]: 'Nhận đơn',
  [ORDER_STATUS.SUPPLIER_DRAFT]: 'Bản nháp NCC',
  [ORDER_STATUS.ADDITIONAL_ORDER]: 'Đơn bổ sung',
  [ORDER_STATUS.MERGED]: 'Đơn đã gộp',
};

export const CHAIN_ORDER_STATUS_TEXT = {
  [ORDER_STATUS.ERROR]: 'Lỗi chưa liên kết SP',
  [ORDER_STATUS.ALL]: 'Tất cả trạng thái',
  [ORDER_STATUS.PENDING]: 'Soạn hàng',
  [ORDER_STATUS.PROCESSING]: 'Đóng gói',
  [ORDER_STATUS.DELIVERY]: 'Giao hàng',
  [ORDER_STATUS.CUSTOMER_CONFIRM]: 'Kiểm hàng',
  [ORDER_STATUS.REJECT]: 'Đã hủy',
  [ORDER_STATUS.CUSTOMER_DRAFT]: 'Bản nháp KH',
  [ORDER_STATUS.COMPLETE]: 'Hoàn thành',
  [ORDER_STATUS.PRE_PROCESSING]: 'Tiền xử lý',
  [ORDER_STATUS.SUPPLIER_CONFIRM]: 'Kiểm hàng',
  [ORDER_STATUS.PENDING_EXECUTE]: 'Nhận đơn',
  [ORDER_STATUS.SUPPLIER_DRAFT]: 'Bản nháp NCC',
  [ORDER_STATUS.ADDITIONAL_ORDER]: 'Đơn bổ sung',
  [ORDER_STATUS.MERGED]: 'Đơn đã gộp',
};

export const ACTION_CHAIN_ORDER_STATUS_TEXT = {
  [ORDER_STATUS.ERROR]: 'Lỗi chưa liên kết SP',
  [ORDER_STATUS.ALL]: 'Tất cả trạng thái',
  [ORDER_STATUS.PENDING]: 'Soạn hàng',
  [ORDER_STATUS.PROCESSING]: 'Đóng gói',
  [ORDER_STATUS.DELIVERY]: 'Giao hàng',
  [ORDER_STATUS.CUSTOMER_CONFIRM]: 'Kiểm hàng',
  [ORDER_STATUS.REJECT]: 'Hủy đơn nhập',
  [ORDER_STATUS.CUSTOMER_DRAFT]: 'Bản nháp KH',
  [ORDER_STATUS.COMPLETE]: 'Hoàn thành',
  [ORDER_STATUS.PRE_PROCESSING]: 'Tiền xử lý',
  [ORDER_STATUS.SUPPLIER_CONFIRM]: 'Kiểm hàng',
  [ORDER_STATUS.PENDING_EXECUTE]: 'Nhận đơn',
  [ORDER_STATUS.SUPPLIER_DRAFT]: 'Bản nháp NCC',
  [ORDER_STATUS.ADDITIONAL_ORDER]: 'Đơn bổ sung',
  [ORDER_STATUS.MERGED]: 'Đơn đã gộp',
};

export const PRODUCTION_PLAN_STATUS = {
  ALL: -1,
  ACTIVE: 0,
  DEACTIVE: 1,
  PENDING: 2,
  FINISHED: 3,
};

export enum DISCOUNT_TYPE {
  PRODUCT = 0,
  ORDER = 1,
  BOTH = 2,
}

export enum STOCK_TYPE {
  STOCK = 0,
  INHERIT_STOCK = 1,
}

export enum DISCOUNT_METHOD {
  PRODUCT_DISCOUNT_BY_QUANTITY = 0,
  PRODUCT_DISCOUNT_BY_GIFT = 1,
  PRODUCT_DISCOUNT_BY_PRICE = 2,
  ORDER_DISCOUNT_BY_ORDER = 3,
  ORDER_DISCOUNT_BY_GIFT = 4,
  ORDER_DISCOUNT_BY_PRODUCT = 5,
}

export const DISCOUNT_TYPE_TEXT = {
  [DISCOUNT_TYPE.PRODUCT]: 'Sản phẩm',
  [DISCOUNT_TYPE.ORDER]: 'Đơn hàng',
  [DISCOUNT_TYPE.BOTH]: 'sản phẩm và đơn hàng',
};

export const DISCOUNT_METHOD_TEXT = {
  [DISCOUNT_METHOD.PRODUCT_DISCOUNT_BY_QUANTITY]: 'Giảm giá theo số lượng mua',
  [DISCOUNT_METHOD.PRODUCT_DISCOUNT_BY_GIFT]: 'Mua hàng tặng hàng',
  [DISCOUNT_METHOD.PRODUCT_DISCOUNT_BY_PRICE]: 'Mua hàng giảm giá hàng',
  [DISCOUNT_METHOD.ORDER_DISCOUNT_BY_ORDER]: 'Giảm giá hoá đơn',
  [DISCOUNT_METHOD.ORDER_DISCOUNT_BY_GIFT]: 'Tặng hàng',
  [DISCOUNT_METHOD.ORDER_DISCOUNT_BY_PRODUCT]: 'Giảm giá hàng',
};

export const STOCK_TYPE_TEXT = {
  [STOCK_TYPE.STOCK]: 'Kho riêng',
  [STOCK_TYPE.INHERIT_STOCK]: 'Kho kế thừa',
};

export enum BILL_PAYMENT_STATUS {
  ALL = -1,
  DEBT = 0,
  PAID = 1,
  CANCELED = 2,
}

export enum BILL_STATUS {
  ALL = -1,
  ACTIVE = 0,
  DRAFT = 1,
}

export enum BILL_DELIVERY_STATUS {
  ALL = -1,
  OUT_FOR_DELIVERY = 0,
  DELIVERED = 1,
  CANCELED = 2,
}

export const BILL_DELIVERY_STATUS_NAME = {
  [BILL_DELIVERY_STATUS.OUT_FOR_DELIVERY]: 'Đang giao hàng',
  [BILL_DELIVERY_STATUS.DELIVERED]: 'Hoàn thành',
  [BILL_DELIVERY_STATUS.CANCELED]: 'Đã hủy',
};

export enum BILL_TYPE {
  BILL = 0,
  RETURN_BILL = 1,
}

export enum BILL_ITEM_PROMOTION_TYPE {
  RATE = 0,
  AMOUNT_UNIT_PRICE = 1,
  AMOUNT_TOTAL_PRICE = 2,
}

export const ADJUSTMENT_TYPE = {
  CO_BUY: 'CO_BUY',
  COMBO: 'combo',
  DIGITAL_MENU: 'digital_menu',
  PRODUCT_COUPON: 'productCoupon',
  SUPPLIER_COUPON: 'supplierCoupon',
  PROMOTION: 'promotion',
  ITEM_PROMOTION: 'item_promotion',
  SALE_PROMOTION: 'sale_promotion',
  ITEM_SALE_PROMOTION: 'item_sale_promotion',
  RETURN_PROMOTION: 'returnPromotion',
};

export enum BILL_PROMOTION_TYPE {
  RATE = 0,
  AMOUNT = 1,
}

export enum BILL_PROMOTION_SCOPE {
  ALL_PRODUCT = 0,
  NO_PROMOTION_PRODUCT = 1,
}

export const BILL_PROMOTION_SCOPE_LIST = [
  {
    value: BILL_PROMOTION_SCOPE.ALL_PRODUCT,
    label: 'Tất cả sản phẩm trong hóa đơn',
  },
  {
    value: BILL_PROMOTION_SCOPE.NO_PROMOTION_PRODUCT,
    label: 'Chỉ sản phẩm chưa áp dụng giảm giá',
  },
];

export enum ORDER_PROMOTION_TYPE {
  RATE = 0,
  AMOUNT = 1,
}

export enum ORDER_PROMOTION_SCOPE {
  ALL_PRODUCT = 0,
  NO_PROMOTION_PRODUCT = 1,
}

export const ORDER_PROMOTION_SCOPE_LIST = [
  {
    value: ORDER_PROMOTION_SCOPE.ALL_PRODUCT,
    label: 'Tất cả sản phẩm trong đơn hàng',
  },
  {
    value: ORDER_PROMOTION_SCOPE.NO_PROMOTION_PRODUCT,
    label: 'Chỉ sản phẩm chưa áp dụng giảm giá',
  },
];

export enum PARTNER_STATUS {
  ACTIVATED = 0,
  DEACTIVATED = 1,
  WAITING_FOR_APPROVAL = 2,
}

export enum SIZE {
  SMALL = 'small',
  DEFAULT = 'default',
  LARGE = 'LARGE',
}

export enum PARTNER_TYPE {
  CUSTOMER = 0,
  SUPPLIER = 1,
  BRANCH = 2,
  WAREHOUSE = 3,
  CENTRAL = 4,
}

export enum PARTNER_IN_CHAIN_TYPE {
  ALL = -1,
  INCHAIN = 0,
  NOT_IN_CHAIN = 1,
}

export const DEFAULT_SLIDE_WIDTH = 96;

export const DEFAULT_SLIDE_SPACING = 12;

export const DEFAULT_SLIDE_COUNT_XS = 3;

export const DEFAULT_SLIDE_COUNT_SM = 4;

export const DEFAULT_SLIDE_COUNT_MD = 4;

export const DEFAULT_SLIDE_COUNT_LG = 4;

export const DEFAULT_SLIDE_COUNT_XL = 5;

export const NOTIFY_OPTION = {
  PRODUCT_BUYING: {
    name: 'Mua bán sản phẩm',
    type: 0,
    options: [
      {
        name: 'Thông báo thay đổi khi báo sản lượng',
        type: 0,
      },
    ],
  },
  ORDER: {
    name: 'Đơn hàng',
    type: 1,
    options: [
      {
        name: 'Nhận thông báo trạng thái đơn hàng bán',
        type: 0,
        subOrderStatus: [
          {
            type: ORDER_STATUS.PENDING_EXECUTE,
            path: '/order/supplier-waiting-execute-cobuy/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.PENDING_EXECUTE],
          },
          {
            type: ORDER_STATUS.PENDING,
            path: '/order/supplier-pending/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.PENDING],
          },
          {
            type: ORDER_STATUS.PROCESSING,
            path: '/order/supplier-processing/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.PROCESSING],
          },
          {
            type: ORDER_STATUS.DELIVERY,
            path: '/order/supplier-delivery/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.DELIVERY],
          },
          {
            type: ORDER_STATUS.CUSTOMER_CONFIRM,
            path: '/order/supplier-confirm-pending/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.CUSTOMER_CONFIRM],
          },
          {
            type: ORDER_STATUS.COMPLETE,
            path: '/order/supplier-completed/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.COMPLETE],
          },
          {
            type: ORDER_STATUS.SUPPLIER_DRAFT,
            path: '/order/supplier-draft/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.SUPPLIER_DRAFT],
          },
          {
            type: ORDER_STATUS.CUSTOMER_DRAFT,
            path: '/order/customer-draft/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.CUSTOMER_DRAFT],
          },
          {
            type: ORDER_STATUS.ADDITIONAL_ORDER,
            name: ORDER_STATUS_TEXT[ORDER_STATUS.ADDITIONAL_ORDER],
          },
          {
            type: ORDER_STATUS.REJECT,
            path: '/order/supplier-reject/',
            name: ACTION_ORDER_STATUS_TEXT[ORDER_STATUS.REJECT],
          },
        ],
      },
      {
        name: 'Nhận thông báo trạng thái đơn nhập hàng',
        type: 1,
        subOrderStatus: [
          {
            type: ORDER_STATUS.PENDING_EXECUTE,
            path: '/order/supplier-waiting-execute-cobuy/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.PENDING_EXECUTE],
          },
          {
            type: ORDER_STATUS.PENDING,
            path: '/order/supplier-pending/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.PENDING],
          },
          {
            type: ORDER_STATUS.PROCESSING,
            path: '/order/supplier-processing/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.PROCESSING],
          },
          {
            type: ORDER_STATUS.DELIVERY,
            path: '/order/supplier-delivery/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.DELIVERY],
          },
          {
            type: ORDER_STATUS.CUSTOMER_CONFIRM,
            path: '/order/supplier-confirm-pending/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.CUSTOMER_CONFIRM],
          },
          {
            type: ORDER_STATUS.COMPLETE,
            path: '/order/supplier-completed/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.COMPLETE],
          },
          {
            type: ORDER_STATUS.SUPPLIER_DRAFT,
            path: '/order/supplier-draft/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.SUPPLIER_DRAFT],
          },
          {
            type: ORDER_STATUS.CUSTOMER_DRAFT,
            path: '/order/customer-draft/',
            name: ORDER_STATUS_TEXT[ORDER_STATUS.CUSTOMER_DRAFT],
          },
          {
            type: ORDER_STATUS.ADDITIONAL_ORDER,
            name: ORDER_STATUS_TEXT[ORDER_STATUS.ADDITIONAL_ORDER],
          },
          {
            type: ORDER_STATUS.REJECT,
            path: '/order/supplier-reject/',
            name: ACTION_ORDER_STATUS_TEXT[ORDER_STATUS.REJECT],
          },
        ],
      },
    ],
  },
  PRODUCT_LINK: {
    name: 'Liên kết sản phẩm',
    type: 2,
    options: [
      {
        name: 'Yêu cầu liên kết',
        type: 0,
      },
      {
        name: 'Cập nhật chính sách',
        type: 1,
      },
    ],
  },
  PRODUCT_RATING: {
    name: 'Liên kết sản phẩm',
    type: 3,
    options: [
      {
        name: 'Nhận thông báo đánh giá sản phẩm',
        type: 0,
      },
    ],
  },
};

export const ENTITY_REPORT_TARGET_TYPE = {
  ORDER: 0,
  PROPOSAL_ITEM: 1,
  BALANCED_ORDER: 2,
};

export enum ENTITY_REPORT_TYPE_VALUE {
  DATE_REPORT = 0,
  WEEK_REPORT = 1,
  MONTH_REPORT = 2,
  ASAP_REPORT = 3,
}

export enum IMPORT_TYPE_VALUE {
  SPECIFIC_IMPORT = 0,
  DATE_IMPORT = 1,
  WEEK_IMPORT = 2,
  MONTH_IMPORT = 3,
  ASAP_IMPORT = 4,
}

export enum IMPORT_METHOD_VALUE {
  JUST_CREATE_IMPORT = 0,
  CREATE_AND_UPDATE_IMPORT = 1,
  CREATE_UPDATE_DELETE_IMPORT = 2,
}

export const IMPORT_STATUS = {
  SUCCESS: 0,
  FAILED: 1,
};

export const ENTITY_REPORT_TYPE = [
  {
    name: 'Báo cáo theo từng ngày',
    type: ENTITY_REPORT_TYPE_VALUE.DATE_REPORT,
  },
  {
    name: 'Báo cáo theo từng tuần',
    type: ENTITY_REPORT_TYPE_VALUE.WEEK_REPORT,
  },
  {
    name: 'Báo cáo theo từng tháng',
    type: ENTITY_REPORT_TYPE_VALUE.MONTH_REPORT,
  },
  {
    name: 'Báo cáo ngay khi có đơn hàng',
    type: ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT,
  },
];

export const IMPORT_TYPE = [
  {
    name: 'Cập nhật theo thời gian cụ thể',
    type: IMPORT_TYPE_VALUE.SPECIFIC_IMPORT,
  },
  {
    name: 'Cập nhật theo từng ngày',
    type: IMPORT_TYPE_VALUE.DATE_IMPORT,
  },
  {
    name: 'Cập nhật theo từng tuần',
    type: IMPORT_TYPE_VALUE.WEEK_IMPORT,
  },
  {
    name: 'Cập nhật theo từng tháng',
    type: IMPORT_TYPE_VALUE.MONTH_IMPORT,
  },
];

export const IMPORT_METHOD = [
  {
    name: 'Chỉ thêm mới',
    type: IMPORT_METHOD_VALUE.JUST_CREATE_IMPORT,
  },
  {
    name: 'Thêm mới và cập nhật',
    type: IMPORT_METHOD_VALUE.CREATE_AND_UPDATE_IMPORT,
  },
  {
    name: 'Thêm mới, cập nhật và xóa',
    type: IMPORT_METHOD_VALUE.CREATE_UPDATE_DELETE_IMPORT,
  },
];

export const DAY_OF_WEEK = [
  {
    name: 'Thứ hai',
    type: 1,
  },
  {
    name: 'Thứ ba',
    type: 2,
  },
  {
    name: 'Thứ tư',
    type: 3,
  },
  {
    name: 'Thứ năm',
    type: 4,
  },
  {
    name: 'Thứ sáu',
    type: 5,
  },
  {
    name: 'Thứ bảy',
    type: 6,
  },
  {
    name: 'Chủ nhật',
    type: 7,
  },
];

export const GROUP_BREAK = [
  ORDER_STATUS.PENDING,
  ORDER_STATUS.DELIVERY,
  ORDER_STATUS.SUPPLIER_CONFIRM,
  ORDER_STATUS.COMPLETE,
];

export const REPORT_OPTION = {
  STATISTIC_ORDER: {
    name: 'Tổng hợp đơn hàng',
    type: 0,
    options: [
      {
        name: 'Đơn hàng bán lẻ',
        type: 0,
      },
      {
        name: 'Đơn hàng bán sỉ',
        type: 1,
      },
    ],
  },
};

export const NOTIFY_APP = {
  SLACK: 0,
  TELEGRAM: 1,
  LARK: 2,
};

export const REPORT_APP = {
  SLACK: 0,
  TELEGRAM: 1,
  LARK: 2,
};

export const NOTIFY_STATUS = {
  ACTIVATED: 0,
  DEACTIVATED: 1,
};

export const ENTITY_REPORT_STATUS = {
  ACTIVATED: 0,
  DEACTIVATED: 1,
};

export const TELEGRAM_BOT = 'https://api.telegram.org/bot';

// red - green - blueconst
export const COLOR_CHART = {
  SALES: '#F05540',
  ORDER: '#26B75D',
  QUANTITY_PRODUCT: '#0C41FF',
  CANCEL_ORDER: '#58b7f1',
};

export const TYPE_DIGITAL_MENU = {
  RETAIL: 0,
  WHOLESALE: 1,
};
export const TYPE_DIGITAL_MENU_STR = {
  RETAIL: '0',
  WHOLESALE: '1',
};

export const DIGITAL_MENU_CATEGORY_PROPOSALITEM_STATUS = {
  ACTIVATED: 0,
  DEACTIVATED: 1,
};

export const DIGITAL_MENU_STATUS = {
  ACTIVATED: 0,
  DEACTIVATED: 1,
  PENDING: 2,
};

export enum DIGITAL_MENU_POLICY_TYPE {
  CASH_DISCOUNT = 1,
  PERCENT_DISCOUNT = 2,
}

export const USER_CUSTOM_DOMAIN_STATUS = {
  ACTIVATED: 0,
  DEACTIVATED: 1,
  WAITING_FOR_APPROVAL: 2,
};

export enum USER_CUSTOM_DOMAIN_TYPE {
  HOME_PAGE = 0,
  ADMIN = 1,
  CHECK = 2,
  BILLING = 3,
  IDENTITY = 4,
  LANDING_PAGE = 8,
  ABOUT_US = 13,
}

export const USER_CUSTOM_DOMAIN_VALUE = {
  [USER_CUSTOM_DOMAIN_TYPE.HOME_PAGE]: 'hubtech',
  [USER_CUSTOM_DOMAIN_TYPE.ADMIN]: 'hub_admin',
  [USER_CUSTOM_DOMAIN_TYPE.BILLING]: 'hub_billing',
  [USER_CUSTOM_DOMAIN_TYPE.CHECK]: 'hub_check',
  [USER_CUSTOM_DOMAIN_TYPE.IDENTITY]: 'hub_identity',
  [USER_CUSTOM_DOMAIN_TYPE.LANDING_PAGE]: 'hub_dcoop',
  [USER_CUSTOM_DOMAIN_TYPE.ABOUT_US]: 'hub_about_us',
};

export const USER_CUSTOM_DOMAIN_KEY = {
  hubtech: USER_CUSTOM_DOMAIN_TYPE.HOME_PAGE,
  hub_admin: USER_CUSTOM_DOMAIN_TYPE.ADMIN,
  hub_billing: USER_CUSTOM_DOMAIN_TYPE.BILLING,
  hub_check: USER_CUSTOM_DOMAIN_TYPE.CHECK,
  hub_identity: USER_CUSTOM_DOMAIN_TYPE.IDENTITY,
  hub_dcoop: USER_CUSTOM_DOMAIN_TYPE.LANDING_PAGE,
  hub_about_us: USER_CUSTOM_DOMAIN_TYPE.ABOUT_US,
};

export const SHIPPING_FEE_TYPE = {
  LOCATION_FREE_SHIP: 1,
  LOCATION_DISCOUNT: 2,
  DISTANCE_AND_PACK: 3,
  NOT_SET_SETTING: 0,
};

export const ORDER = {
  DESC: 0,
  ASC: 1,
};

export const PASSWORD_PATTERN = /^\S{6,20}$/g; // length from 6 to 20 character, not include spacing
export const MESSAGE_INVALID_PASSWORD =
  'Độ dài từ 6 đến 20 ký tự, không chứa khoảng trắng';

export const PREFIX_ADMIN_API = '/admin';

export const QUERY_KEY = {
  ENTITY_ROLE: 'role',
};

export enum SELECT_MODE {
  MULTIPLE = 'multiple',
  TAGS = 'tags',
}

export enum ORDER_MEDIA_TYPE {
  CUSTOMER = 0,
  SUPPLIER = 1,
}

export const IMAGE_UPLOAD_TYPE = {
  MATERIAL_CATEGORY: 'material-category',
  CATEGORY: 'category',
  SUB_CATEGORY: 'sub-category',
  AVATAR: 'avatar',
  AVATARTEXT: 'avatar-text',
  LOGO: 'logo',
  PRODUCT: 'product',
  AREA: 'area',
  BRANCH: 'branch',
  PRODUCT_OBJECT: 'product-object',
  BANNER: 'banner',
  GALLERY: 'gallery',
  BLOG: 'blog',
  CERTIFICATION: 'certification',
  IMAGE: 'image',
  VIDEO: 'video',
};

export const ImageSize = {
  xxs: 160,
  xs: 450,
  sm: 720,
  md: 1080,
  lg: 1920,
};

export const IMAGETYPE: IMAGETYPETYPE = {
  MATERIAL_CATEGORY: {
    xxs: 'xxs',
    xs: 'xs',
  },
  CATEGORY: {
    xxs: 'xxs',
    xs: 'xs',
  },
  SUB_CATEGORY: {
    xxs: 'xxs',
    xs: 'xs',
  },
  AVATAR: {
    xxs: 'xxs',
    xs: 'xs',
  },
  LOGO: {
    xxs: 'xxs',
    xs: 'xs',
  },
  PRODUCT: {
    xxs: 'xxs',
    xs: 'xs',
    sm: 'sm',
  },
  AREA: {
    xxs: 'xxs',
    xs: 'xs',
    sm: 'sm',
  },
  BRANCH: {
    xxs: 'xxs',
    xs: 'xs',
    sm: 'sm',
  },
  PRODUCT_OBJECT: {
    xxs: 'xxs',
    xs: 'xs',
    sm: 'sm',
  },
  BANNER: {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
    lg: 'lg',
  },
  GALLERY: {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
    lg: 'lg',
  },
  BLOG: {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
    lg: 'lg',
  },
  CERTIFICATION: {
    sm: 'sm',
    md: 'md',
  },
  IMAGE: {
    xxs: 'xxs',
    xs: 'xs',
    sm: 'sm',
  },
  VIDEO: {
    xs: 'xs',
    sm: 'sm',
  },
};

export interface IMAGETYPETYPE {
  CERTIFICATION: {
    sm: 'sm';
    md: 'md';
  };
  CATEGORY: {
    xxs: 'xxs';
    xs: 'xs';
  };
  SUB_CATEGORY: {
    xxs: 'xxs';
    xs: 'xs';
  };
  MATERIAL_CATEGORY: {
    xxs: 'xxs';
    xs: 'xs';
  };
  AVATAR: {
    xxs: 'xxs';
    xs: 'xs';
  };
  LOGO: {
    xxs: 'xxs';
    xs: 'xs';
  };
  PRODUCT: {
    xxs: 'xxs';
    xs: 'xs';
    sm: 'sm';
  };
  AREA: {
    xxs: 'xxs';
    xs: 'xs';
    sm: 'sm';
  };
  BRANCH: {
    xxs: 'xxs';
    xs: 'xs';
    sm: 'sm';
  };
  PRODUCT_OBJECT: {
    xxs: 'xxs';
    xs: 'xs';
    sm: 'sm';
  };
  BANNER: {
    xs: 'xs';
    sm: 'sm';
    md: 'md';
    lg: 'lg';
  };
  GALLERY: {
    xs: 'xs';
    sm: 'sm';
    md: 'md';
    lg: 'lg';
  };
  BLOG: {
    xs: 'xs';
    sm: 'sm';
    md: 'md';
    lg: 'lg';
  };
  IMAGE: {
    xxs: 'xxs';
    xs: 'xs';
    sm: 'sm';
  };
  VIDEO: {
    xs: 'xs';
    sm: 'sm';
  };
}

export interface SummaryOrderType {
  supplierID?: string;
  deliveryFee: number;
  deliveryFeeType: number;
  deliveryFeeDetail?: DeliveryFeeDetail;
  totalPrice: bigint;
  totalTemporaryPrice: bigint; // price without shipping fee & discount
  totalItem: number;
  totalAdjustment: bigint;
  adjustments: any[];
  orders?: any[];
  orderSalePromotionConditions?: any[];
}

export interface SummaryBillType {
  supplierID?: string;
  deliveryFee: number;
  deliveryFeeType: number;
  deliveryFeeDetail?: DeliveryFeeDetail;
  totalPrice: bigint;
  totalTemporaryPrice: bigint; // price without shipping fee & discount
  totalItem: number;
  totalAdjustment: bigint;
  adjustments: any[];
  totalDepositMoney: bigint;
  depositMoney: any;
  totalPaidMoney: bigint;
  paidMoney: any;
  deductedMoney: bigint;
  excessMoney: bigint;
  returnMoney: bigint;
  isValidBillReturnMoney: boolean;
  debtMoney: bigint;
  isDebt: boolean;
  returnFee?: any;
  totalReturnFee?: bigint;
  bill?: any;
  orderSalePromotionConditions?: any;
}

export interface PartnerInfoType {
  customerID: string;
  customerOwnerID: string;
  chainCustomerID: string;
  partnerID: string;
  avatar: string;
  displayName: string;
  pricePolicyID?: string;
  proposalPolicyID?: string;
  entityPricePolicyID?: string;
  entityProposalPolicyID?: string;
  note?: any[];
  phoneNumber: string;
  totalDebt: number;
}

export interface SupplierInfoType {
  id: string;
  avatar: string;
  displayName: string;
}

export interface DeliveryFeeDetail {
  distanceShippingFee: number;
  entityDistanceShippingFee?: any;
  customShippingFee: number;
  customShippingFees?: any[];
  entityShippingPolicyItemFee?: number;
  entityShippingPolicyItem?: any;
  packingFee: number;
  discount: number;
  shippingFee?: number;
  isLocationFreeShip?: boolean;
  deliveryFeeType?: number;
  deliveryMethod?: ORDER_DELIVERY_METHOD;
  canDeliver?: boolean;
}

export interface ValidateConstraintsType {
  isValid: boolean;
  isMenuExpired?: boolean;
  isMenuDeleted?: boolean;
  isMenuDeactivated?: boolean;
  isCumulativeDiscountsChanged?: boolean;

  // deactivated category proposal items
  isCategoryProductItemDeactivated?: boolean;
  deactivatedOrderItemIDs?: string[];
  deactivatedCategoryProductItemIDs?: string[];
  deactivatedProductIDs?: any[];
  isProductDeactivated?: boolean;

  // deleted category proposal items
  isCategoryProductItemDeleted?: boolean;
  deletedCategoryProductItemIDs?: string[];
  deletedCategoryOrderItemIDs?: string[];

  // deleted proposal items
  isProductItemDeleted?: boolean;
  deletedProductItemIDs?: string[];
  deletedOrderItemIDs?: string[];

  // out of stock/ not enough proposal items
  isProductItemOutOfStock?: boolean;
  isProductItemNotEnoughQuantity?: boolean;
  outOfStockProductItemIDs?: string[];
  outOfStockOrderItemIDs?: string[];
  notEnoughQuantityProductItems?: NotEnoughQuantity[];
  notEnoughQuantityOrderItems?: NotEnoughQuantity[];
  isProductNotEnoughQuantity?: boolean;
  notEnoughQuantityProducts?: NotEnoughQuantity[];

  // price-changed proposal items
  isProductItemPriceChanged?: boolean;
  priceChangedProductItems?: PriceChanged[];
  priceChangedOrderItems?: PriceChanged[];
  isProductPriceChanged?: boolean;
  priceChangedProducts?: PriceChanged[];

  isAddressChanged?: boolean;
  changedAddress?: AddressData;
}

export interface ValidateBillConstraintsType {
  isValid: boolean;
  isMenuExpired?: boolean;
  isMenuDeleted?: boolean;
  isMenuDeactivated?: boolean;
  isCumulativeDiscountsChanged?: boolean;

  // deactivated category proposal items
  isCategoryProductItemDeactivated?: boolean;
  deactivatedBillItemIDs?: string[];
  deactivatedCategoryProductItemIDs?: string[];
  deactivatedProductIDs?: any[];
  isProductDeactivated?: boolean;

  // deleted category proposal items
  isCategorProductItemDeleted?: boolean;
  deletedCategoryProductItemIDs?: string[];
  deletedCategoryBillItemIDs?: string[];

  // deleted proposal items
  isProductItemDeleted?: boolean;
  deletedProductItemIDs?: string[];
  deletedBillItemIDs?: string[];

  // out of stock/ not enough proposal items
  isProductItemOutOfStock?: boolean;
  isProductItemNotEnoughQuantity?: boolean;
  outOfStockProductItemIDs?: string[];
  outOfStockBillItemIDs?: string[];
  notEnoughQuantityProductItems?: NotEnoughQuantity[];
  notEnoughQuantityBillItems?: NotEnoughQuantity[];
  isProductNotEnoughQuantity?: boolean;
  notEnoughQuantityProducts?: NotEnoughQuantity[];

  // price-changed proposal items
  isProductItemPriceChanged?: boolean;
  priceChangedProductItems?: PriceChanged[];
  priceChangedBillItems?: PriceChanged[];
  isProductPriceChanged?: boolean;
  priceChangedProducts?: PriceChanged[];

  isAddressChanged?: boolean;
  changedAddress?: AddressData;
}

export interface NotEnoughQuantity {
  id: string;
  oldCustomerQuantity: number;
  newCustomerQuantity: number;
  newCustomerQuantityInDB: number;
}

export interface PriceChanged {
  id: string;
  isOldPriceUnitDeleted: boolean;
  areAllPriceUnitsDeleted?: boolean;
  oldPriceUnit: WholesaleProductUnit;
  oldCustomerQuantity: number;
  newPriceUnit: WholesaleProductUnit;
  newCustomerQuantity: number;
}

export interface WholesaleProductUnit {
  id: string;
  price: number;
  prefix: string;
  weight: number;
  postfix: string;
  isRemovable: boolean;
  isHidden: boolean;
  isStandard: boolean;
  isSelected: boolean;
  isCustomerSelected?: boolean;
  allowDecimalQuantity: boolean;
}

export const ORDER_PAYMENT_METHOD_SHORT_TEXT: { [key: number]: string } = {
  [ORDER_PAYMENT_METHOD.CASH]: 'COD',
  [ORDER_PAYMENT_METHOD.E_WALLET]: 'WALLET',
  [ORDER_PAYMENT_METHOD.INTERNET_BANKING]: 'BANKING',
  [ORDER_PAYMENT_METHOD.CREDIT_CARD]: 'CREDIT CARD',
  [ORDER_PAYMENT_METHOD.DEBT]: 'DEBT',
};

export const DELIVERY_SETTING_TABS = {
  DISTANCE_TAB: 'distance_tab',
  LOCATION_TAB: 'location_tab',
  PACKING_TAB: 'packing_tab',
  CUSTOM_TAB: 'custom_tab',
  FREE_SHIP_TAB: 'free_ship_tab',
};

export enum DEVICES {
  DESKTOP,
  TABLET,
  MOBILE,
}

export const DEFAULT_SLOGAN = `Đang tải tiêu đề SEO`;

export enum CHAIN_ENTITY_ROLE {
  SUPPLIER = 0,
  CUSTOMER = 1,
  INVALID = 2,
  CENTRAL = 3,
}

export const VALID_PRICE_UNIT_ELEMENTS_TO_IMPORT_PRICE_POLICY = 5;

export enum ENTITY_PRODUCT_TOTAL_FILTER {
  ALL = -1, // không lọc
  NO_QUANTITY = 0, // không có SL
  HAS_QUANTITY = 1, // có SL
  ENOUGH = 2, // đủ hàng
  MISSING = 3, // thiếu hàng
  REDUNDANT = 4, // thừa hàng
}

export enum SORT_FILTER {
  DESC = 0, // tăng dần
  ASC = 1, // giảm dần
  ALL = -1, // không sort
}

export const STEP_TIME_OPTION = [
  {
    title: '2 phút',
    value: 2,
  },
  {
    title: '10 phút',
    value: 10,
  },
  {
    title: '30 phút',
    value: 30,
  },
  {
    title: '1 giờ',
    value: 60,
  },

  {
    title: '2 giờ',
    value: 120,
  },
  {
    title: '3 giờ',
    value: 180,
  },
  {
    title: '4 giờ',
    value: 240,
  },
];

export const STEP_TIME_FORECAST = [
  {
    title: '10 phút',
    value: 10,
  },
  {
    title: '30 phút',
    value: 30,
  },
  {
    title: '1 giờ',
    value: 60,
  },

  {
    title: '2 giờ',
    value: 120,
  },
  {
    title: '3 giờ',
    value: 180,
  },
  {
    title: '4 giờ',
    value: 240,
  },
];

export enum AUTO_ORDER_SETTING_DETAIL_STATUS {
  ACTIVATED = 0,
  DEACTIVATED = 1,
}

export enum CHAIN_POSITION {
  IN_CHAIN = 0,
  NOT_IN_CHAIN = 1,
  ROOT = 2,
  HEAD_OF_ROOT = 3,
  INVALID = 4,
}

export enum AUTO_ORDER_LOG_TYPE {
  MANUAL_ORDER = 0,
  AUTO_ORDER = 1,
  RESET = 2,
  ERROR_CRON = 3,
  ERROR_SUMMARIZE = 4,
}

export enum AUTO_FORECAST_LOG_TYPE {
  AUTO_FORECAST = 1,
  ERROR_CRON = 2,
}

export enum AUTO_FORECAST_SETTING_DETAIL_ITEM_TYPE {
  PROPOSAL_POLICY = 0,
  PRICE_POLICY = 1,
}

export enum RANGE_SELECT_TYPE {
  BETWEEN = 0,
  FROM = 1,
  TO = 2,
}

export const IMPORT_PRICE_POLICY_COLUMN_NAME = 'IMPORT CHÍNH SÁCH GIÁ BÁN';

export const IMPORT_PROPOSAL_POLICY_COLUMN_NAME = 'IMPORT CHÍNH SÁCH DỰ BÁO';

export const TEMPLATE = [
  {
    label: 'Tất cả thực thể hệ thống',
    description: 'Truy suất nguồn gốc, quản lý kế hoạch trồng trọt',
    code: 'ALL',
    icon: <DashboardFilledIcon height={28} width={28} />,
    color: '#5BB449',
    background: '#EFF7ED',
    types: ['farm', 'store', 'collaborator', 'volunteer'],
  },
  {
    label: 'Nông dân và nhà cung cấp',
    description: 'Truy suất nguồn gốc, quản lý kế hoạch trồng trọt',
    code: 'SUPPLIER',
    icon: <FarmOutlineIcon height={28} width={28} />,
    color: '#5BB449',
    background: '#EFF7ED',
    types: ['farm'],
  },
  {
    label: 'Sở ban, ngành nông nghiệp',
    description: 'Thúc đẩy thương mại nông sản từng địa phương',
    code: 'ORGANIZATION',
    icon: <OrganizationOutlineIcon height={28} width={28} />,
    color: '#5BB449',
    background: '#EFF7ED',
    types: ['farm', 'volunteer'],
  },
  {
    label: 'Doanh nghiệp thực phẩm',
    description: 'Quản lý bán hàng, xây dựng và quản lý chuỗi cung',
    code: 'AGRIBUSINESS',
    icon: <CompanyOutlineIcon height={28} width={28} />,
    color: '#5BB449',
    background: '#EFF7ED',
    types: ['farm', 'store'],
  },
  {
    label: 'Hợp tác xã - Nhà máy',
    description: 'Quản lý và số hóa vùng nguyên liệu, giảm thiểu rủi ro',
    code: 'FACTORY',
    icon: <FactoryOutlineIcon height={28} width={28} />,
    color: '#5BB449',
    background: '#EFF7ED',
    types: ['farm', 'store'],
  },
  {
    label: 'Cửa hàng - Chuỗi cửa hàng',
    description: 'Mua bán với nhà cung cấp, kênh bán hàng',
    code: 'STORE',
    icon: <StoreOutlineIcon height={28} width={28} />,
    color: '#5BB449',
    background: '#EFF7ED',
    types: ['store'],
  },
  {
    label: 'Hộ gia đình',
    description: 'Phương pháp mua hàng nông sản mới',
    code: 'FAMILY',
    icon: <FamilyOutlineIcon height={28} width={28} />,
    color: '#5BB449',
    background: '#EFF7ED',
    types: ['collaborator'],
  },
  {
    label: 'Cộng tác viên',
    description: 'Bán hàng cùng lúc cho nhiều cung cấp',
    code: 'COLLABORATOR',
    icon: <CollaboratorOutlineIcon height={28} width={28} />,
    color: '#5BB449',
    background: '#EFF7ED',
    types: ['collaborator'],
  },

  {
    label: 'Trường học - Nhà hàng',
    description: 'Tìm được nguồn cung chất lượng, giá cả phải chăng',
    code: 'SCHOOL',
    icon: <SchoolOutlineIcon height={28} width={28} />,
    color: '#5BB449',
    background: '#EFF7ED',
    types: ['collaborator'],
  },
  {
    label: 'Trung tâm vì cộng đồng',
    description: 'Giúp đỡ nhiều người và giảm thiểu lãng phí tài nguyên',
    code: 'COMMUNITY',
    icon: <CommunityOutlineIcon height={28} width={28} />,
    color: '#5BB449',
    background: '#EFF7ED',
    types: ['volunteer'],
  },
];

export const ENTITY_ACTION_ROLE = {
  SUPPLIER: 0,
  CUSTOMER: 1,
};

export const POLICY_CODE = {
  MIN_LENGTH: 1,
  MAX_LENGTH: 20,
};

export enum KEY_CODE {
  ENTER = 13,
  NUM_0 = 48,
  NUM_9 = 57,
  NUMPAD_0 = 96,
  NUMPAD_9 = 105,
  RIGHT = 39,
  LEFT = 37,
  UP = 38,
  DOWN = 40,
  EQUAL = 187,
}

export const colorByNumber = {
  0: '#acdfd7',
  1: '#ffe59b',
  2: '#bbd4ff',
  3: '#ddedca',
  4: '#97d5d5',
  5: '#b0df98',
  6: '#c1d198',
  7: '#7dd5d5',
  8: '#94a7f0',
};

export const HOME_TEMPLATE_TYPE = {
  BASIC: 0,
  CUSTOM: 1,
};

export const HOME_TEMPLATE_TYPE_NAME = {
  BASIC: 'Mặc định',
  CUSTOM: 'Góc trái',
};

export const FLOW_CHAIN_UPDATE_STATUS = [
  ORDER_STATUS.PENDING_EXECUTE,
  ORDER_STATUS.DELIVERY,
  ORDER_STATUS.CUSTOMER_CONFIRM,
  ORDER_STATUS.COMPLETE,
];

export const FLOW_UPDATE_STATUS = [
  ORDER_STATUS.PENDING_EXECUTE,
  ORDER_STATUS.PENDING,
  ORDER_STATUS.DELIVERY,
  ORDER_STATUS.CUSTOMER_CONFIRM,
  ORDER_STATUS.COMPLETE,
];

export interface NextUpdateStatusChainOrder {
  tooltip: string;
  code: string;
  icon: any;
  oldStatus: number;
  newStatus: number;
  id: any;
  shouldOpenDeliveredModal: boolean;
  shouldOpenReceivedModal: boolean;
}

export const SALE_TAB_TYPE = {
  CREATE_ORDER: 'CREATE_ORDER',
  UPDATE_ORDER: 'UPDATE_ORDER',
  CREATE_BILL: 'CREATE_BILL',
  UPDATE_BILL: 'UPDATE_BILL',
  CREATE_RETURN_BILL: 'CREATE_RETURN_BILL',
};

export interface SaleActiveTab {
  type: string;
  name: string;
  data: any;
  id: string;
}

export const INIT_SALE_ACTIVE_TAB = {
  type: SALE_TAB_TYPE.CREATE_ORDER,
  name: 'Đơn hàng 1',
  data: {},
  id: '',
};

export const ORDER_TASK_TYPE = {
  SALES_ORDER: 0,
  PURCHASE_ORDER: 1,
};

export const PACKAGE_TYPE = {
  BASIC: 'BASIC',
  PRO: 'PRO',
  ENTERPRISE: 'ENTERPRISE',
  NONE: 'NONE',
};

export const PACKAGE_TYPE_TEXT = {
  [PACKAGE_TYPE.NONE]: 'Chưa có gói',
  [PACKAGE_TYPE.BASIC]: 'Cơ bản',
  [PACKAGE_TYPE.PRO]: 'Chuyên nghiệp',
  [PACKAGE_TYPE.ENTERPRISE]: 'Cao cấp',
};

export enum INVENTORY_AUDIT_STATUS {
  /**
   * Đang kiểm kê
   */
  PENDING = 2,
  /**
   * Đã kiểm kê
   */
  AUDITED = 0,
  /**
   * Đã hủy
   */
  CANCELED = 1,
}

export enum STOCK_ACTION {
  INIT_QUANTITY_INVENTORY_ITEM = 'Khởi tạo sản phẩm trong kho',
  BALANCE_STOCK = 'Cân bằng kho',
  TRANSFER_STOCK_OUT = 'Chuyển hàng khỏi kho',
  TRANSFER_STOCK_IN = 'Chuyển hàng vào kho',
  STOCK_IN = 'Nhập hàng vào kho',
  STOCK_OUT = 'Xuất hàng khỏi kho',
  RETURN_SUPPLIER_INVENTORY_ITEM = 'Trả hàng nhà cung cấp',
  RETURN_CUSTOMER_INVENTORY_ITEM = 'Nhập hàng trả lại',
  INCOMING_STOCK = 'Hàng đang về kho',
}
